'use strict';

var _slicedToArray = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray.js").default;

var _defineProperty = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty.js").default;

var _objectWithoutProperties = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;

var _objectSpread = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2.js").default;

var _toConsumableArray = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;

var _regeneratorRuntime = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;

var _createClass = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass.js").default;

var _classCallCheck = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck.js").default;

var _possibleConstructorReturn = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js").default;

var _getPrototypeOf = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf.js").default;

var _inherits = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits.js").default;

var _wrapNativeSuper = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper.js").default;

var _excluded = ["include_ports", "include_far"],
    _excluded2 = ["airline", "flight_code", "flight_number"],
    _excluded3 = ["place_id", "favorite_id", "favorite_name", "favorite_source", "lat", "lng", "name"],
    _excluded4 = ["airline", "flight_code", "flight_number"];

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

require('@total-typescript/ts-reset');

var zod = require('zod');

var fetcher = require('@bylg/fetcher');

var envSchema = zod.z.enum(["staging", "production"]);
var urlConfig$d = {
  staging: {
    authUrl: "https://api-staging-internal.mozio.com/v2/auth"
  },
  production: {
    authUrl: "https://api.mozio.com/v2/auth"
  }
};
var f$c = new fetcher.FetcherClient({
  ctx: zod.z.object({
    env: envSchema
  })
});
var ERROR_CODES$1 = {
  REFRESH_TOKEN_FAILED: "REFRESH_TOKEN_FAILED"
};

var AuthError = /*#__PURE__*/function (_Error) {
  function AuthError(message) {
    _classCallCheck(this, AuthError);

    return _callSuper(this, AuthError, [message ? "Authentication failed: ".concat(message) : "Authentication failed"]);
  }

  _inherits(AuthError, _Error);

  return _createClass(AuthError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

var authErrorSchema = zod.z.object({
  code: zod.z.union([zod.z.literal("authentication_failed"), zod.z.literal("not_authenticated"), zod.z.literal("permission_denied")]),
  message: zod.z.string().min(1).optional().nullable()
});
var refreshTokensDataSchema = zod.z.union([zod.z.object({
  token: zod.z.string().min(1),
  refresh_token: zod.z.string().min(1)
}), zod.z.object({
  refresh_token: zod.z.array(zod.z.object({
    code: zod.z.string().min(1),
    message: zod.z.string().min(1)
  }))
})]);
var refreshTokens = f$c.fetcher( /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, refreshToken) {
    var _data$refresh_token$;

    var ctx, post, _yield$post, data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          ctx = _ref.ctx, post = _ref.post;
          _context.next = 3;
          return post("".concat(urlConfig$d[ctx.env].authUrl, "/token-refresh/"), refreshTokensDataSchema, {
            refresh_token: refreshToken
          });

        case 3:
          _yield$post = _context.sent;
          data = _yield$post.data;

          if (!("token" in data)) {
            _context.next = 7;
            break;
          }

          return _context.abrupt("return", {
            accessToken: data.token,
            refreshToken: data.refresh_token
          });

        case 7:
          return _context.abrupt("return", {
            error: ERROR_CODES$1.REFRESH_TOKEN_FAILED,
            message: (_data$refresh_token$ = data.refresh_token[0]) === null || _data$refresh_token$ === void 0 ? void 0 : _data$refresh_token$.message
          });

        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
var createAuthQuery = f$c.combineFetchers({
  refreshTokens: refreshTokens
});
var urlConfig$c = {
  staging: {
    esimUrl: "https://api-staging-internal.mozio.com/travel-extras/esim",
    paymentUrl: "https://api-staging-internal.mozio.com/travel-extras/esim"
  },
  production: {
    esimUrl: "https://api.mozio.com/travel-extras/esim",
    paymentUrl: "https://api.mozio.com/travel-extras/esim"
  }
};
var f$b = new fetcher.FetcherClient({
  ctx: zod.z.object({
    env: zod.z.enum(["staging", "production"])
  }),
  headers: {
    lang: zod.z.string(),
    "x-whitelabel": zod.z.string(),
    "white-label-id": zod.z.number().optional(),
    "white-label-name": zod.z.string(),
    "partner-ref": zod.z.string(),
    hostname: zod.z.string(),
    "distinct-id": zod.z.union([zod.z.string(), zod.z.number()]).optional(),
    Authorization: zod.z.string().optional(),
    "api-key": zod.z.string()
  }
});
var getEsimCountries = f$b.fetcher( /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var ctx, get, esimUrl, _yield$get, data;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          ctx = _ref3.ctx, get = _ref3.get;
          esimUrl = urlConfig$c[ctx.env].esimUrl;
          _context2.next = 4;
          return get("".concat(esimUrl, "/country/"), zod.z.array(zod.z.object({
            name: zod.z.string().min(1),
            code: zod.z.string().min(1)
          })));

        case 4:
          _yield$get = _context2.sent;
          data = _yield$get.data;
          return _context2.abrupt("return", data);

        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));

  return function (_x3) {
    return _ref4.apply(this, arguments);
  };
}());
var planSchema = zod.z.array(zod.z.object({
  product_id: zod.z.string().min(1),
  provider: zod.z.string().min(1),
  data_gb: zod.z.string().min(1),
  validity_days: zod.z.number(),
  price: zod.z.object({
    currency: zod.z.string().min(1),
    amount: zod.z.number(),
    symbol: zod.z.string().min(1)
  })
}));

var filterIdenticalPlans = function filterIdenticalPlans(plans) {
  var identicalPlanMap = /* @__PURE__ */new Map();
  plans.forEach(function (plan) {
    var _identicalPlanMap$get, _identicalPlanMap$get2;

    var identicalBy = "".concat(plan.data_gb).concat(plan.validity_days);
    var price = (_identicalPlanMap$get = (_identicalPlanMap$get2 = identicalPlanMap.get(identicalBy)) === null || _identicalPlanMap$get2 === void 0 ? void 0 : _identicalPlanMap$get2.price.amount) !== null && _identicalPlanMap$get !== void 0 ? _identicalPlanMap$get : Number.POSITIVE_INFINITY;

    if (plan.price.amount < price) {
      identicalPlanMap.set(identicalBy, plan);
    }
  });
  return _toConsumableArray(identicalPlanMap.values());
};

var getEsimPlans = f$b.fetcher( /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5, _ref6) {
    var ctx, post, countryCode, currency, esimUrl, _yield$post2, data, uniquePlans;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          ctx = _ref5.ctx, post = _ref5.post;
          countryCode = _ref6.countryCode, currency = _ref6.currency;
          esimUrl = urlConfig$c[ctx.env].esimUrl;
          _context3.next = 5;
          return post("".concat(esimUrl, "/search/"), planSchema, {
            country_code: countryCode,
            currency: currency
          });

        case 5:
          _yield$post2 = _context3.sent;
          data = _yield$post2.data;
          uniquePlans = filterIdenticalPlans(data);
          return _context3.abrupt("return", uniquePlans.map(function (plan) {
            return {
              id: plan.product_id,
              value: plan.product_id,
              dataGb: plan.data_gb,
              price: plan.price,
              validityDays: plan.validity_days,
              // NOTE: `metadata` is used to represent non-front-end model data returned solely for subsequent API calls.
              metadata: {
                purchasePayload: {
                  esim_id: plan.product_id,
                  provider: plan.provider,
                  price: plan.price,
                  country_code: countryCode
                }
              }
            };
          }));

        case 9:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));

  return function (_x4, _x5) {
    return _ref7.apply(this, arguments);
  };
}());
var PURCHASE_ESIM_STATUS = {
  SUCCESS: "SUCCESS",
  REQUIRE_CHECKOUT: "REQUIRE_CHECKOUT"
};
var purchaseSchema = zod.z.union([zod.z.object({
  status: zod.z.enum([PURCHASE_ESIM_STATUS.SUCCESS, PURCHASE_ESIM_STATUS.REQUIRE_CHECKOUT]),
  checkout_url: zod.z.string().url().nullable(),
  price: zod.z.object({
    updated: zod.z.boolean(),
    value: zod.z.number().nullable()
  })
}), authErrorSchema]);
var purchaseEsim = f$b.fetcher( /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref8, _ref9) {
    var ctx, post, couponCode, purchasePayload, purchaseSuccessUrl, purchaseFailUrl, paymentUrl, _yield$post3, data;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          ctx = _ref8.ctx, post = _ref8.post;
          couponCode = _ref9.couponCode, purchasePayload = _ref9.purchasePayload, purchaseSuccessUrl = _ref9.purchaseSuccessUrl, purchaseFailUrl = _ref9.purchaseFailUrl;
          paymentUrl = urlConfig$c[ctx.env].paymentUrl;
          _context4.next = 5;
          return post("".concat(paymentUrl, "/checkout/"), purchaseSchema, _objectSpread(_objectSpread({}, purchasePayload), {}, {
            coupon_code: couponCode,
            success_url: purchaseSuccessUrl,
            cancel_url: purchaseFailUrl
          }));

        case 5:
          _yield$post3 = _context4.sent;
          data = _yield$post3.data;

          if (!("code" in data)) {
            _context4.next = 9;
            break;
          }

          throw new AuthError();

        case 9:
          if (!(data.status === PURCHASE_ESIM_STATUS.SUCCESS)) {
            _context4.next = 11;
            break;
          }

          return _context4.abrupt("return", {
            status: PURCHASE_ESIM_STATUS.SUCCESS
          });

        case 11:
          if (data.checkout_url) {
            _context4.next = 13;
            break;
          }

          throw new Error("No checkout url");

        case 13:
          return _context4.abrupt("return", {
            status: data.status,
            checkoutUrl: data.checkout_url,
            newPrice: data.price.updated && typeof data.price.value === "number" ? data.price.value : void 0
          });

        case 14:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));

  return function (_x6, _x7) {
    return _ref10.apply(this, arguments);
  };
}());
var DISCOUNT_TYPE = {
  FIXED: "FIXED",
  PERCENTAGE: "PERCENTAGE"
};
var validateCoupon = f$b.fetcher( /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref11, _ref12) {
    var ctx, post, couponCode, currency, esimId, esimUrl, _yield$post4, data;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          ctx = _ref11.ctx, post = _ref11.post;
          couponCode = _ref12.couponCode, currency = _ref12.currency, esimId = _ref12.esimId;
          esimUrl = urlConfig$c[ctx.env].esimUrl;
          _context5.next = 5;
          return post("".concat(esimUrl, "/coupon/"), zod.z.union([zod.z.object({
            coupon_code: zod.z.string(),
            esim_id: zod.z.string(),
            discount: zod.z.object({
              type: zod.z.enum([DISCOUNT_TYPE.FIXED, DISCOUNT_TYPE.PERCENTAGE]),
              value: zod.z.number()
            }),
            discounted_price: zod.z.object({
              amount: zod.z.number(),
              currency: zod.z.string(),
              symbol: zod.z.string()
            })
          }), authErrorSchema]), {
            coupon_code: couponCode,
            currency: currency,
            esim_id: esimId
          });

        case 5:
          _yield$post4 = _context5.sent;
          data = _yield$post4.data;

          if (!("code" in data)) {
            _context5.next = 9;
            break;
          }

          throw new AuthError();

        case 9:
          return _context5.abrupt("return", {
            couponCode: data.coupon_code,
            esimId: data.esim_id,
            discount: {
              type: data.discount.type,
              value: data.discount.value
            },
            discountedPrice: {
              amount: data.discounted_price.amount,
              currency: data.discounted_price.currency,
              symbol: data.discounted_price.symbol
            }
          });

        case 10:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));

  return function (_x8, _x9) {
    return _ref13.apply(this, arguments);
  };
}());
var createEsimQuery = f$b.combineFetchers({
  getEsimCountries: getEsimCountries,
  getEsimPlans: getEsimPlans,
  purchaseEsim: purchaseEsim,
  validateCoupon: validateCoupon
});
var urlConfig$b = {
  staging: {
    locationUrl: "https://api-staging-internal.mozio.com/v2/locations/query/",
    flightsUrl: "https://api-staging-internal.mozio.com/v2/flights/",
    airlinesUrl: "https://api-staging-internal.mozio.com/v2/flights/airlines/",
    airportsUrl: "https://api-staging-internal.mozio.com/v2/locations/airports/"
  },
  production: {
    locationUrl: "https://api.mozio.com/v2/locations/query/",
    flightsUrl: "https://api.mozio.com/v2/flights",
    airlinesUrl: "https://api.mozio.com/v2/flights/airlines/",
    airportsUrl: "https://api.mozio.com/v2/locations/airports/"
  }
};
var f$a = new fetcher.FetcherClient({
  ctx: zod.z.object({
    env: envSchema
  }),
  headers: {
    lang: zod.z.string(),
    "api-key": zod.z.string()
  }
});
var locationSchema$2 = zod.z.object({
  display: zod.z.string().optional(),
  lat: zod.z.number().nullable().optional(),
  lng: zod.z.number().nullable().optional(),
  place_id: zod.z.string().optional(),
  value: zod.z.string().optional(),
  terminal: zod.z.string().optional(),
  type: zod.z.enum(["airport", "place", "port", "train_station", ""]).optional(),
  name: zod.z.string().nullable().optional(),
  favorite_id: zod.z.number().optional(),
  favorite_name: zod.z.string().optional(),
  favorite_source: zod.z.enum(["user", "corporation"]).optional()
});
var getSuggestions = f$a.fetcher( /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref14, _ref15) {
    var ctx, get, query, biasCoordinates, otherParams, locationUrl, _ref17, include_ports, include_far, rest, params, paramsString, _yield$get2, data, sortedResults;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          ctx = _ref14.ctx, get = _ref14.get;
          query = _ref15.query, biasCoordinates = _ref15.biasCoordinates, otherParams = _ref15.otherParams;
          locationUrl = urlConfig$b[ctx.env].locationUrl;
          _ref17 = otherParams || {}, include_ports = _ref17.include_ports, include_far = _ref17.include_far, rest = _objectWithoutProperties(_ref17, _excluded);

          if (query) {
            _context6.next = 6;
            break;
          }

          throw new Error("Query not provided");

        case 6:
          params = _objectSpread(_objectSpread({
            query: query,
            include_train_stations: "true",
            include_ports: (include_ports === null || include_ports === void 0 ? void 0 : include_ports.toString()) || "true",
            include_far: (include_far === null || include_far === void 0 ? void 0 : include_far.toString()) || "false"
          }, biasCoordinates ? convertObjectToStrings(biasCoordinates) : {}), rest);
          paramsString = new URLSearchParams(params).toString();
          _context6.next = 10;
          return get("".concat(locationUrl, "?").concat(paramsString), zod.z.object({
            results: zod.z.array(locationSchema$2)
          }));

        case 10:
          _yield$get2 = _context6.sent;
          data = _yield$get2.data;
          sortedResults = data.results.sort(function (a, b) {
            if (!a.favorite_id && b.favorite_id) return 1;
            if (a.favorite_id && !b.favorite_id) return -1;
            return 0;
          });
          return _context6.abrupt("return", sortedResults.map(function (place) {
            return formatPlace(place);
          }));

        case 14:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));

  return function (_x10, _x11) {
    return _ref16.apply(this, arguments);
  };
}());
var getAirlines = f$a.fetcher( /*#__PURE__*/function () {
  var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref18) {
    var ctx, get, airlinesUrl, _yield$get3, data;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          ctx = _ref18.ctx, get = _ref18.get;
          airlinesUrl = urlConfig$b[ctx.env].airlinesUrl;
          _context7.next = 4;
          return get("".concat(airlinesUrl), zod.z.object({
            airlines: zod.z.array(zod.z.object({
              airline_code: zod.z.string(),
              airline_name: zod.z.string()
            }))
          }));

        case 4:
          _yield$get3 = _context7.sent;
          data = _yield$get3.data;
          return _context7.abrupt("return", data.airlines.map(function (airline) {
            return {
              value: airline.airline_code,
              label: airline.airline_name
            };
          }));

        case 7:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));

  return function (_x12) {
    return _ref19.apply(this, arguments);
  };
}());
var flightSchema$1 = zod.z.object({
  destination: zod.z.string(),
  airline: zod.z.object({
    airline_name: zod.z.string(),
    airline_code: zod.z.string()
  }),
  flight_code: zod.z.string(),
  flight_number: zod.z.string(),
  datetime: zod.z.string(),
  origin: zod.z.string(),
  time: zod.z.string()
});
var getFlights = f$a.fetcher( /*#__PURE__*/function () {
  var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref20, _ref21) {
    var ctx, get, options, flightsUrl, paramsString, _yield$get4, data;

    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          ctx = _ref20.ctx, get = _ref20.get;
          options = _ref21.options;
          flightsUrl = urlConfig$b[ctx.env].flightsUrl;
          paramsString = new URLSearchParams(options).toString();
          _context8.next = 6;
          return get("".concat(flightsUrl, "?").concat(paramsString), zod.z.object({
            flights: zod.z.array(flightSchema$1)
          }));

        case 6:
          _yield$get4 = _context8.sent;
          data = _yield$get4.data;
          return _context8.abrupt("return", data.flights.map(function (flight) {
            var airline = flight.airline,
                flight_code = flight.flight_code,
                flight_number = flight.flight_number,
                rest = _objectWithoutProperties(flight, _excluded2);

            return _objectSpread(_objectSpread({}, rest), {}, {
              airlineCode: airline.airline_code,
              airlineName: airline.airline_name,
              flightCode: flight_code,
              flightNumber: flight_number
            });
          }));

        case 9:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));

  return function (_x13, _x14) {
    return _ref22.apply(this, arguments);
  };
}());
var getAirports = f$a.fetcher( /*#__PURE__*/function () {
  var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref23, _ref24) {
    var ctx, get, query, airportsUrl, params, paramsString, _yield$get5, data;

    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          ctx = _ref23.ctx, get = _ref23.get;
          query = _ref24.query;
          airportsUrl = urlConfig$b[ctx.env].airportsUrl;
          params = {
            query: query
          };
          paramsString = new URLSearchParams(params).toString();
          _context9.next = 7;
          return get("".concat(airportsUrl, "?").concat(paramsString), zod.z.object({
            results: zod.z.array(locationSchema$2)
          }));

        case 7:
          _yield$get5 = _context9.sent;
          data = _yield$get5.data;
          return _context9.abrupt("return", data.results.map(function (airport) {
            return formatPlace(airport);
          }));

        case 10:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));

  return function (_x15, _x16) {
    return _ref25.apply(this, arguments);
  };
}());

var formatPlace = function formatPlace(location) {
  var place_id = location.place_id,
      favorite_id = location.favorite_id,
      favorite_name = location.favorite_name,
      favorite_source = location.favorite_source,
      lat = location.lat,
      lng = location.lng,
      name = location.name,
      rest = _objectWithoutProperties(location, _excluded3);

  return _objectSpread(_objectSpread({}, rest), {}, {
    lat: lat !== null && lat !== void 0 ? lat : void 0,
    lng: lng !== null && lng !== void 0 ? lng : void 0,
    name: name !== null && name !== void 0 ? name : void 0,
    placeId: place_id,
    favoriteId: favorite_id,
    favoriteName: favorite_name,
    favoriteSource: favorite_source
  });
};

var convertObjectToStrings = function convertObjectToStrings(object) {
  var convertedObject = {};

  for (var key in object) {
    if (object[key] !== void 0 && object[key] !== null) {
      var _object$key;

      convertedObject[key] = typeof object[key] === "number" ? (_object$key = object[key]) === null || _object$key === void 0 ? void 0 : _object$key.toString() : object[key];
    }
  }

  return convertedObject;
};

var createHertzQuery = f$a.combineFetchers({
  getSuggestions: getSuggestions,
  getAirlines: getAirlines,
  getFlights: getFlights,
  getAirports: getAirports
});
var nonAuthFetcher = new fetcher.FetcherClient({
  ctx: zod.z.object({
    env: envSchema
  }),
  headers: {
    "api-key": zod.z.string()
  }
});
var authFetcher = new fetcher.FetcherClient({
  ctx: zod.z.object({
    env: envSchema,
    reservationHashId: zod.z.string()
  }),
  headers: {
    authorization: zod.z.string(),
    "api-key": zod.z.string()
  }
});
var apiTripStatusSchema = zod.z.enum(["cancelled", "not_started", "driver_departed_to_pickup", "driver_arrived_at_pickup", "driver_departed_to_dropoff", "driver_arrived_at_dropoff", "no_show_reported_by_driver"]).optional().default("not_started");
var DRIVER_TRIP_STATUS = {
  CANCELLED: "cancelled",
  NOT_STARTED: "notStarted",
  DRIVING_TO_PICK_UP: "drivingToPickUp",
  ARRIVED_AT_PICK_UP: "arrivedAtPickUp",
  DRIVING_TO_DROP_OFF: "drivingToDropOff",
  ARRIVED_AT_DROP_OFF: "arrivedAtDropOff",
  NO_SHOW: "noShow"
};
var urlConfig$a = {
  staging: {
    tripUrl: "https://api-staging-internal.mozio.com/v2/data-entry/vehicle-tracking/reservations",
    changeStatusUrl: "https://api-staging-internal.mozio.com/v2/data-entry/vehicle-tracking/reservations",
    authUrl: "https://api-staging-internal.mozio.com/v2/auth/drivers/sso-login/",
    tripUrlV2: "https://api-staging-internal.mozio.com/v2/reservations",
    changeStatusUrlV2: "https://tracking-staging.mozio.com/v1/trackings",
    directionsUrlV2: "https://api-staging-internal.mozio.com/v2/locations/directions/",
    latestTrackingEventUrlV2: "https://tracking-staging.mozio.com/v1/trackings"
  },
  production: {
    tripUrl: "https://api.mozio.com/v2/data-entry/vehicle-tracking/reservations",
    changeStatusUrl: "https://api.mozio.com/v2/data-entry/vehicle-tracking/reservations",
    authUrl: "https://api.mozio.com/v2/auth/drivers/sso-login/",
    tripUrlV2: "https://api.mozio.com/v2/reservations",
    changeStatusUrlV2: "https://tracking-api.mozio.com/v1/trackings",
    directionsUrlV2: "https://api.mozio.com/v2/locations/directions/",
    latestTrackingEventUrlV2: "https://tracking-api.mozio.com/v1/trackings"
  }
};

var getNextStatus = function getNextStatus(currentStatus) {
  if (currentStatus === DRIVER_TRIP_STATUS.NO_SHOW || currentStatus === DRIVER_TRIP_STATUS.ARRIVED_AT_DROP_OFF) {
    throw new Error("You cannot update '".concat(currentStatus, "' status."));
  }

  var nextStatus = {
    cancelled: DRIVER_TRIP_STATUS.CANCELLED,
    notStarted: DRIVER_TRIP_STATUS.DRIVING_TO_PICK_UP,
    drivingToPickUp: DRIVER_TRIP_STATUS.ARRIVED_AT_PICK_UP,
    arrivedAtPickUp: DRIVER_TRIP_STATUS.DRIVING_TO_DROP_OFF,
    drivingToDropOff: DRIVER_TRIP_STATUS.ARRIVED_AT_DROP_OFF
  };
  return nextStatus[currentStatus];
};

var mapApiTripStatusToTripStatus = function mapApiTripStatusToTripStatus(status) {
  var map = {
    cancelled: DRIVER_TRIP_STATUS.CANCELLED,
    not_started: DRIVER_TRIP_STATUS.NOT_STARTED,
    driver_departed_to_pickup: DRIVER_TRIP_STATUS.DRIVING_TO_PICK_UP,
    driver_arrived_at_pickup: DRIVER_TRIP_STATUS.ARRIVED_AT_PICK_UP,
    driver_departed_to_dropoff: DRIVER_TRIP_STATUS.DRIVING_TO_DROP_OFF,
    driver_arrived_at_dropoff: DRIVER_TRIP_STATUS.ARRIVED_AT_DROP_OFF,
    no_show_reported_by_driver: DRIVER_TRIP_STATUS.NO_SHOW
  };
  return map[status];
};

var mapTripStatusToApiTripStatus = function mapTripStatusToApiTripStatus(tripStatus) {
  var map = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, DRIVER_TRIP_STATUS.CANCELLED, "cancelled"), DRIVER_TRIP_STATUS.NOT_STARTED, "not_started"), DRIVER_TRIP_STATUS.DRIVING_TO_PICK_UP, "driver_departed_to_pickup"), DRIVER_TRIP_STATUS.ARRIVED_AT_PICK_UP, "driver_arrived_at_pickup"), DRIVER_TRIP_STATUS.DRIVING_TO_DROP_OFF, "driver_departed_to_dropoff"), DRIVER_TRIP_STATUS.ARRIVED_AT_DROP_OFF, "driver_arrived_at_dropoff"), DRIVER_TRIP_STATUS.NO_SHOW, "no_show_reported_by_driver");

  return map[tripStatus];
};

var getNavigationDestination = function getNavigationDestination(status, departureCoords, destinationCoords) {
  var map = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, DRIVER_TRIP_STATUS.CANCELLED, void 0), DRIVER_TRIP_STATUS.NOT_STARTED, void 0), DRIVER_TRIP_STATUS.DRIVING_TO_PICK_UP, departureCoords), DRIVER_TRIP_STATUS.ARRIVED_AT_PICK_UP, void 0), DRIVER_TRIP_STATUS.DRIVING_TO_DROP_OFF, destinationCoords), DRIVER_TRIP_STATUS.ARRIVED_AT_DROP_OFF, void 0), DRIVER_TRIP_STATUS.NO_SHOW, void 0);

  return map[status];
};

var getDirectionsV2 = authFetcher.fetcher( /*#__PURE__*/function () {
  var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref26, _ref27) {
    var post, ctx, category, start, end, _yield$post5, data, segments;

    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          post = _ref26.post, ctx = _ref26.ctx;
          category = _ref27.category, start = _ref27.start, end = _ref27.end;
          _context10.next = 4;
          return post(urlConfig$a[ctx.env].directionsUrlV2, zod.z.object({
            segments: zod.z.array(zod.z.object({
              category: zod.z.string(),
              polyline_points: zod.z.string(),
              distance: zod.z.number(),
              duration: zod.z.number()
            }))
          }), {
            segments: [{
              category: category,
              start: start,
              end: end
            }]
          });

        case 4:
          _yield$post5 = _context10.sent;
          data = _yield$post5.data;
          segments = data.segments.map(function (segment) {
            return {
              category: segment.category,
              polyline_points: segment.polyline_points,
              distance: segment.distance,
              duration: segment.duration
            };
          });
          return _context10.abrupt("return", {
            segments: segments
          });

        case 8:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));

  return function (_x17, _x18) {
    return _ref28.apply(this, arguments);
  };
}());
var getLatestTrackingEventV2 = authFetcher.fetcher( /*#__PURE__*/function () {
  var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref29) {
    var ctx, get, env, reservationHashId, _yield$get6, data, response, status;

    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          ctx = _ref29.ctx, get = _ref29.get;
          env = ctx.env, reservationHashId = ctx.reservationHashId;
          _context11.next = 4;
          return get("".concat(urlConfig$a[env].latestTrackingEventUrlV2, "/").concat(reservationHashId, "/events/latest"), zod.z.union([zod.z.object({
            status: apiTripStatusSchema
          }), zod.z.object({
            detail: zod.z.string()
          })]));

        case 4:
          _yield$get6 = _context11.sent;
          data = _yield$get6.data;
          response = _yield$get6.response;

          if (!(response.status === 404)) {
            _context11.next = 9;
            break;
          }

          return _context11.abrupt("return", {
            status: DRIVER_TRIP_STATUS.NOT_STARTED
          });

        case 9:
          if (!("detail" in data)) {
            _context11.next = 11;
            break;
          }

          return _context11.abrupt("return", {
            status: DRIVER_TRIP_STATUS.NOT_STARTED
          });

        case 11:
          status = mapApiTripStatusToTripStatus(data.status);
          return _context11.abrupt("return", {
            status: status
          });

        case 13:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));

  return function (_x19) {
    return _ref30.apply(this, arguments);
  };
}());
var updateToNextStatusV2 = authFetcher.fetcher( /*#__PURE__*/function () {
  var _ref33 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(_ref31, _ref32) {
    var ctx, post, currentStatus, position, env, reservationHashId, _ref34, lat, lng, nextStatus, _yield$post6, data;

    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          ctx = _ref31.ctx, post = _ref31.post;
          currentStatus = _ref32.currentStatus, position = _ref32.position;
          env = ctx.env, reservationHashId = ctx.reservationHashId;
          _ref34 = position || {}, lat = _ref34.latitude, lng = _ref34.longitude;
          nextStatus = mapTripStatusToApiTripStatus(getNextStatus(currentStatus));
          _context12.next = 7;
          return post("".concat(urlConfig$a[env].changeStatusUrlV2, "/").concat(reservationHashId, "/events"), zod.z.object({
            status: apiTripStatusSchema
          }), _objectSpread({
            status: nextStatus
          }, position ? {
            coordinates: {
              lat: lat,
              lng: lng
            }
          } : {
            coordinates: {
              lat: 0,
              lng: 0
            }
          }));

        case 7:
          _yield$post6 = _context12.sent;
          data = _yield$post6.data;
          return _context12.abrupt("return", {
            status: mapApiTripStatusToTripStatus(data.status)
          });

        case 10:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));

  return function (_x20, _x21) {
    return _ref33.apply(this, arguments);
  };
}());
var getTripV2 = authFetcher.fetcher( /*#__PURE__*/function () {
  var _ref36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_ref35) {
    var _data$voyage$vehicle$;

    var ctx, get, env, reservationHashId, amenitySchema, _yield$get7, data, amenities;

    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          ctx = _ref35.ctx, get = _ref35.get;
          env = ctx.env, reservationHashId = ctx.reservationHashId;
          amenitySchema = zod.z.object({
            key: zod.z.string(),
            name: zod.z.string(),
            image_url: zod.z.string().url(),
            included: zod.z.boolean()
          });
          _context13.next = 5;
          return get("".concat(urlConfig$a[env].tripUrlV2, "/").concat(reservationHashId), zod.z.object({
            id: zod.z.string(),
            timestamp: zod.z.string(),
            confirmation_number: zod.z.string(),
            pickup_instructions: zod.z.string(),
            first_name: zod.z.string(),
            last_name: zod.z.string(),
            phone_number: zod.z.string(),
            voyage: zod.z.object({
              num_passengers: zod.z.number(),
              amenities: zod.z.array(amenitySchema),
              departure_datetime: zod.z.string(),
              arrival_datetime: zod.z.string(),
              provider_name: zod.z.string(),
              start_location: zod.z.object({
                formatted_address: zod.z.string().min(1),
                lat: zod.z.number(),
                lng: zod.z.number()
              }),
              end_location: zod.z.object({
                formatted_address: zod.z.string().min(1),
                lat: zod.z.number(),
                lng: zod.z.number()
              }),
              booking_details: zod.z.object({
                notes: zod.z.string(),
                wait_time: zod.z.number()
              }),
              vehicle: zod.z.object({
                image_url: zod.z.string(),
                max_bags: zod.z.number(),
                max_passengers: zod.z.number(),
                total_bags: zod.z.number(),
                vehicle_class_detail: zod.z.object({
                  display_name: zod.z.string()
                })
              })
            })
          }));

        case 5:
          _yield$get7 = _context13.sent;
          data = _yield$get7.data;
          amenities = data.voyage.amenities.map(function (amenity) {
            return {
              key: amenity.key,
              name: amenity.name,
              included: amenity.included,
              imageUrl: amenity.image_url
            };
          });
          return _context13.abrupt("return", {
            amenities: amenities,
            id: data.id,
            timestamp: data.timestamp,
            confirmationNumber: data.confirmation_number,
            pickupInstructions: data.pickup_instructions,
            waitTime: data.voyage.booking_details.wait_time,
            providerName: data.voyage.provider_name,
            from: {
              location: data.voyage.start_location.formatted_address
            },
            to: {
              location: data.voyage.end_location.formatted_address
            },
            endLocation: {
              latitude: data.voyage.start_location.lat,
              longitude: data.voyage.start_location.lng
            },
            customerNotes: data.voyage.booking_details.notes,
            arrivalDatetime: data.voyage.arrival_datetime,
            departureDatetime: data.voyage.departure_datetime,
            phone: data.phone_number,
            vehicle: {
              imageUrl: data.voyage.vehicle.image_url,
              maxBags: data.voyage.vehicle.max_bags,
              maxPassengers: data.voyage.vehicle.max_passengers,
              vehicleClass: data.voyage.vehicle.vehicle_class_detail.display_name
            },
            passengerCardProps: {
              hasCustomerNotes: !!data.voyage.booking_details.notes,
              name: "".concat(data.first_name, " ").concat(data.last_name),
              passengerCount: data.voyage.num_passengers,
              luggageCount: (_data$voyage$vehicle$ = data.voyage.vehicle.total_bags) !== null && _data$voyage$vehicle$ !== void 0 ? _data$voyage$vehicle$ : void 0
            }
          });

        case 9:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));

  return function (_x22) {
    return _ref36.apply(this, arguments);
  };
}());
var getTrip = authFetcher.fetcher( /*#__PURE__*/function () {
  var _ref38 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_ref37) {
    var _data$flight_info$fli, _data$flight_info, _data$customer_notes, _data$num_bags;

    var ctx, get, env, reservationHashId, _yield$get8, data, status, navigationDestination;

    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          ctx = _ref37.ctx, get = _ref37.get;
          env = ctx.env, reservationHashId = ctx.reservationHashId;
          _context14.next = 4;
          return get("".concat(urlConfig$a[env].tripUrl, "/").concat(reservationHashId), zod.z.object({
            passenger_information: zod.z.object({
              first_name: zod.z.string().min(1),
              last_name: zod.z.string().min(1),
              phone: zod.z.string().min(1)
            }),
            num_passengers: zod.z.number().min(1),
            num_bags: zod.z.number().min(1).nullable(),
            start_location: zod.z.object({
              full_address: zod.z.string().min(1),
              lat: zod.z.number(),
              lng: zod.z.number()
            }),
            departure_datetime: zod.z.string().min(1),
            end_location: zod.z.object({
              full_address: zod.z.string().min(1),
              lat: zod.z.number(),
              lng: zod.z.number()
            }),
            arrival_datetime: zod.z.string().min(1).nullable(),
            flight_info: zod.z.object({
              flight_code: zod.z.string().min(1)
            }).nullable(),
            driver: zod.z.object({
              user_external_id: zod.z.number()
            }),
            status: apiTripStatusSchema,
            customer_notes: zod.z.string().nullable()
          }));

        case 4:
          _yield$get8 = _context14.sent;
          data = _yield$get8.data;
          status = mapApiTripStatusToTripStatus(data.status);
          navigationDestination = getNavigationDestination(status, {
            latitude: data.start_location.lat,
            longitude: data.start_location.lng
          }, {
            latitude: data.end_location.lat,
            longitude: data.end_location.lng
          });
          return _context14.abrupt("return", {
            from: {
              location: data.start_location.full_address,
              time: new Date(data.departure_datetime)
            },
            to: {
              location: data.end_location.full_address,
              time: data.arrival_datetime ? new Date(data.arrival_datetime) : void 0
            },
            flight: (_data$flight_info$fli = (_data$flight_info = data.flight_info) === null || _data$flight_info === void 0 ? void 0 : _data$flight_info.flight_code) !== null && _data$flight_info$fli !== void 0 ? _data$flight_info$fli : void 0,
            status: status,
            navigationDestination: navigationDestination,
            customerNotes: (_data$customer_notes = data.customer_notes) !== null && _data$customer_notes !== void 0 ? _data$customer_notes : void 0,
            phone: data.passenger_information.phone,
            driver: {
              id: data.driver.user_external_id
            },
            passengerCardProps: {
              hasCustomerNotes: !!data.customer_notes,
              name: "".concat(data.passenger_information.first_name, " ").concat(data.passenger_information.last_name),
              passengerCount: data.num_passengers,
              luggageCount: (_data$num_bags = data.num_bags) !== null && _data$num_bags !== void 0 ? _data$num_bags : void 0
            }
          });

        case 9:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));

  return function (_x23) {
    return _ref38.apply(this, arguments);
  };
}());
var updateToNextStatus = authFetcher.fetcher( /*#__PURE__*/function () {
  var _ref41 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(_ref39, _ref40) {
    var ctx, post, currentStatus, position, changeStatusUrl, _ref42, lat, lng, nextStatus, _yield$post7, data;

    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          ctx = _ref39.ctx, post = _ref39.post;
          currentStatus = _ref40.currentStatus, position = _ref40.position;
          changeStatusUrl = urlConfig$a[ctx.env].changeStatusUrl;
          _ref42 = position || {}, lat = _ref42.latitude, lng = _ref42.longitude;
          nextStatus = getNextStatus(currentStatus);
          _context15.next = 7;
          return post("".concat(changeStatusUrl, "/").concat(ctx.reservationHashId, "/change-status/"), zod.z.union([zod.z.object({
            status: apiTripStatusSchema
          }), zod.z.object({
            non_field_errors: zod.z.array(zod.z.object({
              message: zod.z.string()
            })).min(1)
          })]), _objectSpread({
            status: mapTripStatusToApiTripStatus(nextStatus)
          }, position ? {
            position: {
              lat: lat,
              lng: lng
            }
          } : {}));

        case 7:
          _yield$post7 = _context15.sent;
          data = _yield$post7.data;

          if (!("non_field_errors" in data)) {
            _context15.next = 11;
            break;
          }

          return _context15.abrupt("return", {
            userError: data.non_field_errors[0].message
          });

        case 11:
          if (!(nextStatus === mapApiTripStatusToTripStatus(data.status))) {
            _context15.next = 13;
            break;
          }

          return _context15.abrupt("return", {
            status: nextStatus
          });

        case 13:
          throw new Error("Returned status don't match with sent one.");

        case 14:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));

  return function (_x24, _x25) {
    return _ref41.apply(this, arguments);
  };
}());
var cancelTrip = authFetcher.fetcher( /*#__PURE__*/function () {
  var _ref45 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(_ref43, _ref44) {
    var ctx, post, position, changeStatusUrl, _ref46, lat, lng, _yield$post8, returnedStatus;

    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          ctx = _ref43.ctx, post = _ref43.post;
          position = _ref44.position;
          changeStatusUrl = urlConfig$a[ctx.env].changeStatusUrl;
          _ref46 = position || {}, lat = _ref46.latitude, lng = _ref46.longitude;
          _context16.next = 6;
          return post("".concat(changeStatusUrl, "/").concat(ctx.reservationHashId, "/change-status/"), zod.z.object({
            status: apiTripStatusSchema
          }), _objectSpread({
            status: mapTripStatusToApiTripStatus(DRIVER_TRIP_STATUS.NO_SHOW)
          }, position ? {
            position: {
              lat: lat,
              lng: lng
            }
          } : {}));

        case 6:
          _yield$post8 = _context16.sent;
          returnedStatus = _yield$post8.data.status;

          if (!(DRIVER_TRIP_STATUS.NO_SHOW === mapApiTripStatusToTripStatus(returnedStatus))) {
            _context16.next = 10;
            break;
          }

          return _context16.abrupt("return", DRIVER_TRIP_STATUS.NO_SHOW);

        case 10:
          throw new Error("Returned status don't match with sent one.");

        case 11:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));

  return function (_x26, _x27) {
    return _ref45.apply(this, arguments);
  };
}());
var cancelTripV2 = authFetcher.fetcher( /*#__PURE__*/function () {
  var _ref49 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(_ref47, _ref48) {
    var ctx, post, position, env, reservationHashId, _ref50, lat, lng, _yield$post9, returnedStatus;

    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          ctx = _ref47.ctx, post = _ref47.post;
          position = _ref48.position;
          env = ctx.env, reservationHashId = ctx.reservationHashId;
          _ref50 = position || {}, lat = _ref50.latitude, lng = _ref50.longitude;
          _context17.next = 6;
          return post("".concat(urlConfig$a[env].changeStatusUrlV2, "/").concat(reservationHashId, "/events"), zod.z.object({
            status: apiTripStatusSchema
          }), _objectSpread({
            status: mapTripStatusToApiTripStatus(DRIVER_TRIP_STATUS.NO_SHOW)
          }, position ? {
            position: {
              lat: lat,
              lng: lng
            }
          } : {}));

        case 6:
          _yield$post9 = _context17.sent;
          returnedStatus = _yield$post9.data.status;

          if (!(DRIVER_TRIP_STATUS.NO_SHOW === mapApiTripStatusToTripStatus(returnedStatus))) {
            _context17.next = 10;
            break;
          }

          return _context17.abrupt("return", DRIVER_TRIP_STATUS.NO_SHOW);

        case 10:
          throw new Error("Returned status don't match with sent one.");

        case 11:
        case "end":
          return _context17.stop();
      }
    }, _callee17);
  }));

  return function (_x28, _x29) {
    return _ref49.apply(this, arguments);
  };
}());
var getToken = nonAuthFetcher.fetcher( /*#__PURE__*/function () {
  var _ref53 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(_ref51, _ref52) {
    var ctx, post, ssoToken, _yield$post10, token;

    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          ctx = _ref51.ctx, post = _ref51.post;
          ssoToken = _ref52.ssoToken;
          _context18.next = 4;
          return post(urlConfig$a[ctx.env].authUrl, zod.z.object({
            refresh_token: zod.z.string(),
            token: zod.z.string()
          }), {
            key: ssoToken
          });

        case 4:
          _yield$post10 = _context18.sent;
          token = _yield$post10.data.token;
          return _context18.abrupt("return", token);

        case 7:
        case "end":
          return _context18.stop();
      }
    }, _callee18);
  }));

  return function (_x30, _x31) {
    return _ref53.apply(this, arguments);
  };
}());
var createDriverQuery = nonAuthFetcher.combineFetchers({
  getToken: getToken
});
var createAuthDriverQuery = authFetcher.combineFetchers({
  getTrip: getTrip,
  updateToNextStatus: updateToNextStatus,
  cancelTrip: cancelTrip,
  getDirectionsV2: getDirectionsV2,
  getLatestTrackingEventV2: getLatestTrackingEventV2,
  updateToNextStatusV2: updateToNextStatusV2,
  getTripV2: getTripV2,
  cancelTripV2: cancelTripV2
});
var urlConfig$9 = {
  production: {
    whiteLabelUrl: "https://api.mozio.com/v2/whitelabels"
  },
  staging: {
    whiteLabelUrl: "https://api-staging-internal.mozio.com/v2/whitelabels"
  }
};
var f$9 = new fetcher.FetcherClient({
  ctx: zod.z.object({
    env: envSchema
  })
});

var getInjectContent = function getInjectContent(_ref54) {
  var metadata = _ref54.metadata,
      themeVars = _ref54.themeVars,
      config = _ref54.config;
  var title = metadata.title,
      description = metadata.description,
      keywords = metadata.keywords,
      imageUrl = metadata.imageUrl,
      faviconUrl = metadata.faviconUrl,
      canonicalUrl = metadata.canonicalUrl,
      url = metadata.url;
  return "\n  <title>".concat(title, "</title>\n  <meta name=\"description\" content=\"").concat(description, "\">\n  <meta name=\"keywords\" content=\"").concat(keywords, "\">\n  <meta name=\"og:title\" content=\"").concat(title, "\">\n  <meta name=\"og:description\" content=\"").concat(description, "\">\n  <meta name=\"og:url\" content=\"").concat(url, "\">\n  <meta name=\"og:image\" content=\"").concat(imageUrl, "\">\n  <link rel=\"icon\" type=\"image/x-icon\" href=\"").concat(faviconUrl, "\">\n  <link rel=\"canonical\" href=\"").concat(canonicalUrl, "\">\n  <style>\n    :root {\n      ").concat(Object.entries(themeVars).map(function (_ref55) {
    var _ref56 = _slicedToArray(_ref55, 2),
        key = _ref56[0],
        value = _ref56[1];

    return "".concat(key, ": ").concat(value, ";");
  }).join(" "), "\n    }\n  </style>\n  <script>\n    window.WHITE_LABEL_CONFIG = ").concat(JSON.stringify(config), ";\n  </script>\n  ");
};

var colorKeySchema = zod.z.enum(["white", "black", "primary-100", "primary-200", "primary-300", "primary-400", "primary-500", "primary-contrast", "secondary-100", "secondary-200", "secondary-300", "secondary-400", "secondary-500", "secondary-contrast", "neutral-100", "neutral-200", "neutral-300", "neutral-400", "neutral-500", "neutral-600", "neutral-700", "neutral-800", "neutral-900", "success-100", "success-200", "success-300", "success-400", "success-500", "error-100", "error-200", "error-300", "error-400", "error-500", "warning-100", "warning-200", "warning-300", "warning-400", "warning-500"]);
var whiteLabelSchema = zod.z.object({
  config: zod.z.object({
    NAME: zod.z.string().min(1),
    ID: zod.z.number(),
    PARTNER_REF: zod.z.string().min(1),
    FIRST_BACKGROUND_COLOR: zod.z.string().min(1),
    FOURTH_BACKGROUND_COLOR: zod.z.string().min(1),
    CTA_BACKGROUND_COLOR: zod.z.string().min(1),
    FIRST_CONTRAST_COLOR: zod.z.string().min(1),
    FOURTH_CONTRAST_COLOR: zod.z.string().min(1),
    CTA_CONTRAST_COLOR: zod.z.string().min(1),
    HEADER_CUSTOM_HEIGHT: zod.z.string().min(1),
    HEADER_CUSTOM_LOGO_HEIGHT: zod.z.string(),
    HEADER_BG: colorKeySchema,
    HEADER_BORDER_COLOR: colorKeySchema,
    HEADER_CREATE_ACCOUNT_BTN_BG: colorKeySchema,
    HEADER_CREATE_ACCOUNT_BTN_TEXT: colorKeySchema,
    HEADER_CREATE_ACCOUNT_BTN_HOVER_BG: colorKeySchema,
    HEADER_CREATE_ACCOUNT_BTN_HOVER_TEXT: colorKeySchema,
    HEADER_SIGN_IN_BTN_BG: colorKeySchema,
    HEADER_SIGN_IN_BTN_TEXT: colorKeySchema,
    HEADER_SIGN_IN_BTN_HOVER_BG: colorKeySchema,
    HEADER_SIGN_IN_BTN_HOVER_TEXT: colorKeySchema,
    HEADER_GENERAL_BTN_BG: colorKeySchema,
    HEADER_GENERAL_BTN_TEXT: colorKeySchema,
    HEADER_GENERAL_BTN_HOVER_BG: colorKeySchema,
    HEADER_GENERAL_BTN_HOVER_TEXT: colorKeySchema,
    DEFAULT_CURRENCY: zod.z.string(),
    AUTODETECT_CURRENCY_BY_IP: zod.z.boolean(),
    FOOTER_SOCIALS: zod.z.array(zod.z.tuple([zod.z.enum(["facebook", "twitter", "instagram", "linkedin"]), zod.z.string().url()])),
    CUSTOM_SOCIAL_LOGO: zod.z.string(),
    CUSTOM_LOGO: zod.z.string(),
    CUSTOM_FOOTER_LOGO: zod.z.string().nullable(),
    CUSTOM_DOMAINS: zod.z.array(zod.z.tuple([zod.z.string(), zod.z.string()])),
    CUSTOM_FAVICON: zod.z.string(),
    ALLOW_ONLY_REGISTERED: zod.z.boolean(),
    ESIM_COVER_IMAGE: zod.z.string(),
    ESIM_SUPPORT_EMAIL: zod.z.string().min(1),
    ESIM_SUPPORT_PHONE_NUMBERS: zod.z.array(zod.z.tuple([zod.z.string(), zod.z.string().min(1)])).min(1).refine(function (numbers) {
      var defaultNumber = numbers.find(function (n) {
        return n[0] === "default";
      });

      if (!defaultNumber || defaultNumber[1].length === 0) {
        return false;
      }

      return true;
    }, function (value) {
      return {
        message: "ESIM_SUPPORT_PHONE_NUMBERS must have a default phone number but received: ".concat(value)
      };
    }),
    PARKING_COVER_IMAGE: zod.z.string(),
    PARKING_SHOW_HEADER_ESIM: zod.z.boolean(),
    PARKING_SHOW_HEADER_TRANSFER: zod.z.boolean(),
    PARKING_SHOW_ESIM_BANNER: zod.z.boolean(),
    PARKING_SHOW_TRANSFER_BANNER: zod.z.boolean(),
    PARKING_SHOW_LOUNGES_BANNER: zod.z.boolean(),
    SHOW_SIGNIN_BUTTON: zod.z.boolean(),
    CUSTOM_LOGO_LINK: zod.z.string().optional(),
    SHOW_RESEND_BOOKING: zod.z.boolean(),
    REGISTER_TA_SHOW: zod.z.boolean(),
    TRAVEL_AGENT_COMPANY: zod.z.string().optional(),
    HEADER_CUSTOM_LINKS: zod.z.array(zod.z.tuple([zod.z.string(), zod.z.string()])),
    SHOW_TA_REPORT_BUTTON: zod.z.boolean(),
    EDITABLE_MY_INFORMATION: zod.z.boolean()
  })
});

var parseBootstrapJs = function parseBootstrapJs(script, domain) {
  if (script.includes("window.WL_OBJ = null")) {
    console.error("Api returns null when fetching ".concat(domain, "."));
    return;
  }

  if (script.startsWith("<html>")) {
    var _$exec;

    var regexResult = (_$exec = /<h1>(.*)<\/h1>/.exec(script)) !== null && _$exec !== void 0 ? _$exec : [];
    var errorMessage = regexResult[1];
    console.error("Api error when fetching ".concat(domain, ": ").concat(errorMessage));
    return;
  }

  var whiteLabelData = whiteLabelSchema.parse(JSON.parse(script.replace("window.WL_OBJ = ", "")));
  whiteLabelData.defaultDomain = domain;
  return whiteLabelData;
};

var getWhiteLabel = f$9.fetcher( /*#__PURE__*/function () {
  var _ref58 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(_ref57, domain) {
    var ctx, whiteLabelUrl, response, script;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          ctx = _ref57.ctx;
          whiteLabelUrl = urlConfig$9[ctx.env].whiteLabelUrl;
          _context19.next = 4;
          return fetch("".concat(whiteLabelUrl, "/whitelabel/bootstrap.js?name=").concat(domain));

        case 4:
          response = _context19.sent;
          _context19.next = 7;
          return response.text();

        case 7:
          script = _context19.sent;
          return _context19.abrupt("return", parseBootstrapJs(script, domain));

        case 9:
        case "end":
          return _context19.stop();
      }
    }, _callee19);
  }));

  return function (_x32, _x33) {
    return _ref58.apply(this, arguments);
  };
}());
var WHITE_LABELS = {
  esim: ["esim-test.mozio.com", // NOTE: for testing only
  "esim-agent-test.mozio.com", // NOTE: for testing only
  "esim-test-staging.mozio.com", // NOTE: for staging testing only
  "tui-uk.mozio.com", "tui-nl.mozio.com", "tui-be.mozio.com", "tui-de.mozio.com", "tui-nordic.mozio.com", "itaairways.mozio.com", "stafftravelvoyage.mozio.com", "firstchoice.mozio.com"],
  parking: ["esky.mozio.com", "stafftravelvoyage.mozio.com"],
  userCenter: ["esky.mozio.com"]
};
var WHITE_LABELS_CUSTOM_DOMAINS = /* @__PURE__ */new Set(["esim-test.mozio.com", // NOTE: for testing only
"esim-agent-test.mozio.com", // NOTE: for testing only
"esim-test-staging.mozio.com", // NOTE: for staging testing only
"tui-uk.mozio.com", "tui-nl.mozio.com", "tui-be.mozio.com", "tui-de.mozio.com", "tui-no.mozio.com", "tui-fr.mozio.com", "tui-dk.mozio.com", "tui-fi.mozio.com", "tui-se.mozio.com", "tui-at.mozio.com", "itaairways.mozio.com"]);

var getWhiteLabelDomains = function getWhiteLabelDomains(data) {
  var customDomains = data.config.CUSTOM_DOMAINS.filter(function (customDomain) {
    return WHITE_LABELS_CUSTOM_DOMAINS.has(customDomain[0]);
  }).map(function (_ref59) {
    var _ref60 = _slicedToArray(_ref59, 2),
        domain = _ref60[0],
        localeAndCurrency = _ref60[1];

    return _objectSpread(_objectSpread({}, data), {}, {
      domain: domain,
      locale: localeAndCurrency.split(",")[0],
      currency: localeAndCurrency.split(",")[1]
    });
  });
  var customDefaultDomain = data.config.CUSTOM_DOMAINS.find(function (_ref61) {
    var _ref62 = _slicedToArray(_ref61, 1),
        domain = _ref62[0];

    return domain === data.defaultDomain;
  });

  if (!customDefaultDomain) {
    customDomains.push(_objectSpread(_objectSpread({}, data), {}, {
      domain: data.defaultDomain
    }));
  }

  return customDomains;
};

var getWhiteLabelCustomDomains = function getWhiteLabelCustomDomains(data) {
  var customDomains = data.config.CUSTOM_DOMAINS.map(function (_ref63) {
    var _ref64 = _slicedToArray(_ref63, 2),
        domain = _ref64[0],
        localeAndCurrency = _ref64[1];

    return _objectSpread(_objectSpread({}, data), {}, {
      domain: domain,
      locale: localeAndCurrency.split(",")[0],
      currency: localeAndCurrency.split(",")[1]
    });
  });
  var customDefaultDomain = data.config.CUSTOM_DOMAINS.find(function (_ref65) {
    var _ref66 = _slicedToArray(_ref65, 1),
        domain = _ref66[0];

    return domain === data.defaultDomain;
  });

  if (!customDefaultDomain) {
    customDomains.push(_objectSpread(_objectSpread({}, data), {}, {
      domain: data.defaultDomain
    }));
  }

  return customDomains;
};

var getAllWhiteLabelsDomains = f$9.fetcher( /*#__PURE__*/function () {
  var _ref69 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(_ref67, _ref68) {
    var ctx, projectName, whiteLabelUrl, whiteLabels;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          ctx = _ref67.ctx;
          projectName = _ref68.projectName;
          whiteLabelUrl = urlConfig$9[ctx.env].whiteLabelUrl;
          _context21.next = 5;
          return Promise.all(WHITE_LABELS[projectName].map( /*#__PURE__*/function () {
            var _ref70 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(domain) {
              return _regeneratorRuntime.wrap(function _callee20$(_context20) {
                while (1) switch (_context20.prev = _context20.next) {
                  case 0:
                    return _context20.abrupt("return", fetch("".concat(whiteLabelUrl, "/whitelabel/bootstrap.js?name=").concat(domain)).then(function (response) {
                      return response.text();
                    }).then(function (script) {
                      return parseBootstrapJs(script, domain);
                    }));

                  case 1:
                  case "end":
                    return _context20.stop();
                }
              }, _callee20);
            }));

            return function (_x36) {
              return _ref70.apply(this, arguments);
            };
          }()));

        case 5:
          whiteLabels = _context21.sent;
          return _context21.abrupt("return", whiteLabels.filter(Boolean).flatMap(function (whiteLabel) {
            return getWhiteLabelDomains(whiteLabel);
          }));

        case 7:
        case "end":
          return _context21.stop();
      }
    }, _callee21);
  }));

  return function (_x34, _x35) {
    return _ref69.apply(this, arguments);
  };
}());

var getBootstrapJsUrl = function getBootstrapJsUrl(env, domain) {
  return "".concat(urlConfig$9[env].whiteLabelUrl, "/whitelabel/bootstrap.js?name=").concat(domain);
};

var createWhiteLabelQuery = f$9.combineFetchers({
  getWhiteLabel: getWhiteLabel,
  getAllWhiteLabelsDomains: getAllWhiteLabelsDomains
});
var whiteLabelServices = {
  getInjectContent: getInjectContent,
  getWhiteLabelDomains: getWhiteLabelDomains,
  getWhiteLabelCustomDomains: getWhiteLabelCustomDomains,
  getBootstrapJsUrl: getBootstrapJsUrl
};
var urlConfig$8 = {
  staging: {
    currencyUrl: "https://api-staging-internal.mozio.com/v2/currencies",
    geolocationUrl: "https://api-staging-internal.mozio.com/v2/geolocation"
  },
  production: {
    currencyUrl: "https://api.mozio.com/v2/currencies",
    geolocationUrl: "https://api.mozio.com/v2/geolocation"
  }
};
var f$8 = new fetcher.FetcherClient({
  ctx: zod.z.object({
    env: envSchema
  }),
  headers: {
    lang: zod.z.string(),
    "api-key": zod.z.string()
  }
});
var getCurrencies = f$8.fetcher( /*#__PURE__*/function () {
  var _ref72 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(_ref71) {
    var ctx, get, currencyUrl, _yield$get9, data;

    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          ctx = _ref71.ctx, get = _ref71.get;
          currencyUrl = urlConfig$8[ctx.env].currencyUrl;
          _context22.next = 4;
          return get("".concat(currencyUrl, "/"), zod.z.object({
            currencies: zod.z.array(zod.z.object({
              code: zod.z.string().min(1),
              name: zod.z.string().min(1),
              symbol: zod.z.string().min(1)
            }))
          }));

        case 4:
          _yield$get9 = _context22.sent;
          data = _yield$get9.data;
          return _context22.abrupt("return", data.currencies);

        case 7:
        case "end":
          return _context22.stop();
      }
    }, _callee22);
  }));

  return function (_x37) {
    return _ref72.apply(this, arguments);
  };
}());
var getCurrencyCodeByIp = f$8.fetcher( /*#__PURE__*/function () {
  var _ref74 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(_ref73) {
    var ctx, get, geolocationUrl, _yield$get10, data;

    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          ctx = _ref73.ctx, get = _ref73.get;
          geolocationUrl = urlConfig$8[ctx.env].geolocationUrl;
          _context23.next = 4;
          return get("".concat(geolocationUrl, "/"), zod.z.object({
            currency_code: zod.z.string().min(1),
            is_currency_supported: zod.z.boolean()
          }));

        case 4:
          _yield$get10 = _context23.sent;
          data = _yield$get10.data;
          return _context23.abrupt("return", data.is_currency_supported ? data.currency_code : "");

        case 7:
        case "end":
          return _context23.stop();
      }
    }, _callee23);
  }));

  return function (_x38) {
    return _ref74.apply(this, arguments);
  };
}());
var createCurrencyQuery = f$8.combineFetchers({
  getCurrencies: getCurrencies,
  getCurrencyCodeByIp: getCurrencyCodeByIp
});
var urlConfig$7 = {
  staging: {
    resendEmailUrl: "https://api-staging-internal.mozio.com/v2/resend-confirmation-email"
  },
  production: {
    resendEmailUrl: "https://api.mozio.com/v2/resend-confirmation-email"
  }
};
var f$7 = new fetcher.FetcherClient({
  ctx: zod.z.object({
    env: envSchema
  }),
  headers: {
    "api-key": zod.z.string(),
    "Content-Type": zod.z.string()
  }
});
var resendConfirmationEmail = f$7.fetcher( /*#__PURE__*/function () {
  var _ref76 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(_ref75, email) {
    var ctx, headers, resendEmailUrl, response;
    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          ctx = _ref75.ctx, headers = _ref75.headers;
          resendEmailUrl = urlConfig$7[ctx.env].resendEmailUrl;
          _context24.next = 4;
          return fetch("".concat(resendEmailUrl, "/"), {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
              email: email
            })
          });

        case 4:
          response = _context24.sent;

          if (!(response.status !== 204)) {
            _context24.next = 7;
            break;
          }

          throw new Error("Failed to resend confirmation email");

        case 7:
          return _context24.abrupt("return", true);

        case 8:
        case "end":
          return _context24.stop();
      }
    }, _callee24);
  }));

  return function (_x39, _x40) {
    return _ref76.apply(this, arguments);
  };
}());
var createConfirmationQuery = f$7.combineFetchers({
  resendConfirmationEmail: resendConfirmationEmail
});
var urlConfig$6 = {
  staging: {
    reservationUrl: "https://api-staging-internal.mozio.com/v2/reservations",
    reportsUrl: "https://api-staging-internal.mozio.com/v2/travel_agent/reports"
  },
  production: {
    reservationUrl: "https://api.mozio.com/v2/reservations",
    reportsUrl: "https://api.mozio.com/v2/travel_agent/reports"
  }
};
var f$6 = new fetcher.FetcherClient({
  ctx: zod.z.object({
    env: envSchema
  }),
  headers: {
    "api-key": zod.z.string(),
    "Content-Type": zod.z.string(),
    Authorization: zod.z.string().optional()
  }
});
var reservationSchema = zod.z.union([zod.z.object({
  count: zod.z.number(),
  next: zod.z.string().nullable(),
  previous: zod.z.string().nullable(),
  results: zod.z.array(zod.z.object({
    id: zod.z.string().min(1),
    confirmation_number: zod.z.string().min(1),
    first_name: zod.z.string().min(1),
    last_name: zod.z.string().min(1),
    total_price: zod.z.object({
      compact: zod.z.string().min(1)
    }),
    voyage: zod.z.object({
      departure_datetime: zod.z.string().min(1),
      start_location: zod.z.object({
        custom_name: zod.z.string().min(1)
      }),
      end_location: zod.z.object({
        custom_name: zod.z.string().min(1)
      })
    }),
    timestamp: zod.z.string().min(1)
  }))
}), authErrorSchema]);
var getReservations$1 = f$6.fetcher( /*#__PURE__*/function () {
  var _ref79 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(_ref77, _ref78) {
    var ctx, get, ordering, past, page, pageSize, includeCancellations, reservationUrl, params, paramsString, _yield$get11, data;

    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          ctx = _ref77.ctx, get = _ref77.get;
          ordering = _ref78.ordering, past = _ref78.past, page = _ref78.page, pageSize = _ref78.pageSize, includeCancellations = _ref78.includeCancellations;
          reservationUrl = urlConfig$6[ctx.env].reservationUrl;
          params = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, ordering ? {
            ordering: ordering
          } : {}), past ? {
            past: "true"
          } : {
            past: "false"
          }), page ? {
            page: page.toString()
          } : {}), pageSize ? {
            page_size: pageSize.toString()
          } : {}), includeCancellations ? {
            include_cancellations: "true"
          } : {});
          paramsString = new URLSearchParams(params).toString();
          _context25.next = 7;
          return get("".concat(reservationUrl, "/?").concat(paramsString), reservationSchema);

        case 7:
          _yield$get11 = _context25.sent;
          data = _yield$get11.data;

          if (!("code" in data)) {
            _context25.next = 11;
            break;
          }

          throw new AuthError();

        case 11:
          return _context25.abrupt("return", {
            count: data.count,
            next: data.next,
            previous: data.previous,
            results: data.results.map(function (result) {
              return {
                id: result.id,
                confirmationNumber: result.confirmation_number,
                firstName: result.first_name,
                lastName: result.last_name,
                totalPrice: {
                  compact: result.total_price.compact
                },
                voyage: {
                  departureDatetime: result.voyage.departure_datetime,
                  startLocation: {
                    customName: result.voyage.start_location.custom_name
                  },
                  endLocation: {
                    customName: result.voyage.end_location.custom_name
                  }
                },
                timestamp: result.timestamp
              };
            })
          });

        case 12:
        case "end":
          return _context25.stop();
      }
    }, _callee25);
  }));

  return function (_x41, _x42) {
    return _ref79.apply(this, arguments);
  };
}());
var reportSchema = zod.z.object({
  url: zod.z.string()
});
var getReportUrl = f$6.fetcher( /*#__PURE__*/function () {
  var _ref82 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(_ref80, _ref81) {
    var ctx, get, startMonth, startYear, endMonth, endYear, travelDateInterval, includeWithdrawn, reportsUrl, params, paramsString, _yield$get12, data;

    return _regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          ctx = _ref80.ctx, get = _ref80.get;
          startMonth = _ref81.startMonth, startYear = _ref81.startYear, endMonth = _ref81.endMonth, endYear = _ref81.endYear, travelDateInterval = _ref81.travelDateInterval, includeWithdrawn = _ref81.includeWithdrawn;
          reportsUrl = urlConfig$6[ctx.env].reportsUrl;
          params = {
            travel_date: travelDateInterval ? "1" : "0",
            include_withdrawn: includeWithdrawn.toString()
          };
          paramsString = new URLSearchParams(params).toString();
          _context26.next = 7;
          return get("".concat(reportsUrl, "/").concat(startMonth, "/").concat(startYear, "/").concat(endMonth, "/").concat(endYear, "/?").concat(paramsString), reportSchema);

        case 7:
          _yield$get12 = _context26.sent;
          data = _yield$get12.data;

          if (!("code" in data)) {
            _context26.next = 11;
            break;
          }

          throw new AuthError();

        case 11:
          return _context26.abrupt("return", {
            url: data.url
          });

        case 12:
        case "end":
          return _context26.stop();
      }
    }, _callee26);
  }));

  return function (_x43, _x44) {
    return _ref82.apply(this, arguments);
  };
}());
var createTransferQuery = f$6.combineFetchers({
  getReservations: getReservations$1,
  getReportUrl: getReportUrl
});
var urlConfig$5 = {
  staging: {
    userUrl: "https://api-staging-internal.mozio.com/v2/auth/users"
  },
  production: {
    userUrl: "https://api.mozio.com/v2/auth/users"
  }
};
var f$5 = new fetcher.FetcherClient({
  ctx: zod.z.object({
    env: envSchema
  }),
  headers: {
    "api-key": zod.z.string(),
    "Content-Type": zod.z.string(),
    Authorization: zod.z.string().optional()
  }
});
var USER_TYPE = {
  NORMAL: 0,
  TRAVEL_AGENT: 1,
  CORPORATE: 2,
  GBT_TC: 3
};
var userSchema = zod.z.union([zod.z.object({
  id: zod.z.number(),
  email: zod.z.string(),
  first_name: zod.z.string(),
  last_name: zod.z.string(),
  user_type: zod.z.nativeEnum(USER_TYPE),
  country_code_name: zod.z.string(),
  country_code: zod.z.string(),
  phone_number_national: zod.z.string().optional(),
  currency: zod.z.string(),
  language: zod.z.string()
}), authErrorSchema]);
var getMyUser = f$5.fetcher( /*#__PURE__*/function () {
  var _ref84 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(_ref83) {
    var ctx, get, userUrl, _yield$get13, data;

    return _regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          ctx = _ref83.ctx, get = _ref83.get;
          userUrl = urlConfig$5[ctx.env].userUrl;
          _context27.next = 4;
          return get("".concat(userUrl, "/me"), userSchema);

        case 4:
          _yield$get13 = _context27.sent;
          data = _yield$get13.data;

          if (!("code" in data)) {
            _context27.next = 8;
            break;
          }

          throw new AuthError();

        case 8:
          return _context27.abrupt("return", {
            email: data.email,
            firstName: data.first_name,
            lastName: data.last_name,
            userType: data.user_type,
            countryCode: data.country_code_name,
            callingCode: data.country_code,
            phoneNumber: data.phone_number_national,
            currency: data.currency,
            locale: data.language,
            id: data.id
          });

        case 9:
        case "end":
          return _context27.stop();
      }
    }, _callee27);
  }));

  return function (_x45) {
    return _ref84.apply(this, arguments);
  };
}());
var updateMyUser = f$5.fetcher( /*#__PURE__*/function () {
  var _ref87 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(_ref85, _ref86) {
    var ctx, patch, id, firstName, lastName, email, countryCode, phoneNumber, currency, locale, userUrl, _yield$patch, data;

    return _regeneratorRuntime.wrap(function _callee28$(_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          ctx = _ref85.ctx, patch = _ref85.patch;
          id = _ref86.id, firstName = _ref86.firstName, lastName = _ref86.lastName, email = _ref86.email, countryCode = _ref86.countryCode, phoneNumber = _ref86.phoneNumber, currency = _ref86.currency, locale = _ref86.locale;
          userUrl = urlConfig$5[ctx.env].userUrl;
          _context28.next = 5;
          return patch("".concat(userUrl, "/").concat(id), userSchema, {
            first_name: firstName,
            last_name: lastName,
            email: email,
            country_code_name: countryCode.toLowerCase(),
            phone_number: phoneNumber,
            currency: currency,
            language: locale
          });

        case 5:
          _yield$patch = _context28.sent;
          data = _yield$patch.data;

          if (!("code" in data)) {
            _context28.next = 9;
            break;
          }

          throw new AuthError();

        case 9:
          return _context28.abrupt("return", {
            email: data.email,
            firstName: data.first_name,
            lastName: data.last_name,
            userType: data.user_type,
            countryCode: data.country_code_name,
            callingCode: data.country_code,
            phoneNumber: data.phone_number_national,
            currency: data.currency,
            locale: data.language,
            id: data.id
          });

        case 10:
        case "end":
          return _context28.stop();
      }
    }, _callee28);
  }));

  return function (_x46, _x47) {
    return _ref87.apply(this, arguments);
  };
}());
var changePassword = f$5.fetcher( /*#__PURE__*/function () {
  var _ref90 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(_ref88, _ref89) {
    var ctx, post, id, oldPassword, newPassword, userUrl, _yield$post11, data, response;

    return _regeneratorRuntime.wrap(function _callee29$(_context29) {
      while (1) switch (_context29.prev = _context29.next) {
        case 0:
          ctx = _ref88.ctx, post = _ref88.post;
          id = _ref89.id, oldPassword = _ref89.oldPassword, newPassword = _ref89.newPassword;
          userUrl = urlConfig$5[ctx.env].userUrl;
          _context29.next = 5;
          return post("".concat(userUrl, "/").concat(id, "/change_password/"), zod.z.union([zod.z.object({
            success: zod.z.boolean(),
            msg: zod.z.string().optional()
          }), authErrorSchema]), {
            old_password: oldPassword,
            password: newPassword
          });

        case 5:
          _yield$post11 = _context29.sent;
          data = _yield$post11.data;
          response = _yield$post11.response;

          if (!("code" in data)) {
            _context29.next = 10;
            break;
          }

          throw new AuthError();

        case 10:
          if (data.success) {
            _context29.next = 12;
            break;
          }

          throw new Error(data.msg);

        case 12:
          return _context29.abrupt("return", {
            success: data.success
          });

        case 13:
        case "end":
          return _context29.stop();
      }
    }, _callee29);
  }));

  return function (_x48, _x49) {
    return _ref90.apply(this, arguments);
  };
}());
var createUsersQuery = f$5.combineFetchers({
  getMyUser: getMyUser,
  updateMyUser: updateMyUser,
  changePassword: changePassword
});
var urlConfig$4 = {
  staging: {
    driverTrackingUrl: "https://api-staging-internal.mozio.com/v2/data-entry/vehicle-tracking/driver-tracking-report",
    getVehiclesUrl: "https://api-staging-internal.mozio.com/v2/data-entry/vehicle-tracking/vehicles",
    driverTrackedRidesUrl: "https://api-staging-internal.mozio.com/v2/data-entry/vehicle-tracking/driver-tracking-report/driver-tracked-reservations",
    driverUntrackedRidesUrl: "https://api-staging-internal.mozio.com/v2/data-entry/vehicle-tracking/driver-tracking-report/driver-untracked-reservations"
  },
  production: {
    driverTrackingUrl: "https://api.mozio.com/v2/data-entry/vehicle-tracking/driver-tracking-report",
    getVehiclesUrl: "https://api.mozio.com/v2/data-entry/vehicle-tracking/vehicles",
    driverTrackedRidesUrl: "https://api.mozio.com/v2/data-entry/vehicle-tracking/driver-tracking-report/driver-tracked-reservations",
    driverUntrackedRidesUrl: "https://api.mozio.com/v2/data-entry/vehicle-tracking/driver-tracking-report/driver-untracked-reservations"
  }
};
var f$4 = new fetcher.FetcherClient({
  ctx: zod.z.object({
    env: envSchema
  }),
  headers: {
    authorization: zod.z.string()
  }
});
var getDriversRides = f$4.fetcher( /*#__PURE__*/function () {
  var _ref93 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(_ref91, _ref92) {
    var ctx, get, page, startDate, endDate, driverTrackingUrl, pageSize, params, paramsString, _yield$get14, data;

    return _regeneratorRuntime.wrap(function _callee30$(_context30) {
      while (1) switch (_context30.prev = _context30.next) {
        case 0:
          ctx = _ref91.ctx, get = _ref91.get;
          page = _ref92.page, startDate = _ref92.startDate, endDate = _ref92.endDate;
          driverTrackingUrl = urlConfig$4[ctx.env].driverTrackingUrl;
          pageSize = 6;
          params = {
            page_size: pageSize.toString(),
            page: page.toString(),
            start_date: startDate.toISOString().split("T")[0],
            end_date: endDate.toISOString().split("T")[0]
          };
          paramsString = new URLSearchParams(params).toString();
          _context30.next = 8;
          return get("".concat(driverTrackingUrl, "/table/?").concat(paramsString), zod.z.object({
            count: zod.z.number(),
            next: zod.z.string().url().nullable(),
            previous: zod.z.string().url().nullable(),
            results: zod.z.array(zod.z.object({
              email: zod.z.string().min(1).nullable(),
              name: zod.z.string().min(1),
              total_ride_count: zod.z.number(),
              tracked_ride_count: zod.z.number()
            }))
          }));

        case 8:
          _yield$get14 = _context30.sent;
          data = _yield$get14.data;
          return _context30.abrupt("return", {
            drivers: data.results.map(function (driver) {
              var _driver$email;

              return {
                id: (_driver$email = driver.email) !== null && _driver$email !== void 0 ? _driver$email : driver.name,
                // email is null when driver is not assigned, so use driver name as id
                name: driver.name,
                totalRideCount: driver.total_ride_count,
                trackedRideCount: driver.tracked_ride_count
              };
            }),
            totalPageCount: Math.ceil(data.count / pageSize)
          });

        case 11:
        case "end":
          return _context30.stop();
      }
    }, _callee30);
  }));

  return function (_x50, _x51) {
    return _ref93.apply(this, arguments);
  };
}());
var getRideTrackingSummary = f$4.fetcher( /*#__PURE__*/function () {
  var _ref96 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(_ref94, _ref95) {
    var ctx, get, startDate, endDate, driverTrackingUrl, params, paramsString, _yield$get15, data;

    return _regeneratorRuntime.wrap(function _callee31$(_context31) {
      while (1) switch (_context31.prev = _context31.next) {
        case 0:
          ctx = _ref94.ctx, get = _ref94.get;
          startDate = _ref95.startDate, endDate = _ref95.endDate;
          driverTrackingUrl = urlConfig$4[ctx.env].driverTrackingUrl;
          params = {
            start_date: startDate.toISOString().split("T")[0],
            end_date: endDate.toISOString().split("T")[0]
          };
          paramsString = new URLSearchParams(params).toString();
          _context31.next = 7;
          return get("".concat(driverTrackingUrl, "/pie-chart/?").concat(paramsString), zod.z.object({
            total_ride_count: zod.z.number(),
            tracked_ride_count: zod.z.number()
          }));

        case 7:
          _yield$get15 = _context31.sent;
          data = _yield$get15.data;
          return _context31.abrupt("return", {
            trackedRideCount: data.tracked_ride_count,
            untrackedRideCount: data.total_ride_count - data.tracked_ride_count
          });

        case 10:
        case "end":
          return _context31.stop();
      }
    }, _callee31);
  }));

  return function (_x52, _x53) {
    return _ref96.apply(this, arguments);
  };
}());
var getVehicles = f$4.fetcher( /*#__PURE__*/function () {
  var _ref99 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(_ref97, _ref98) {
    var ctx, get, page, PAGE_SIZE, getVehiclesUrl, _yield$get16, data;

    return _regeneratorRuntime.wrap(function _callee32$(_context32) {
      while (1) switch (_context32.prev = _context32.next) {
        case 0:
          ctx = _ref97.ctx, get = _ref97.get;
          page = _ref98.page;
          PAGE_SIZE = 5;
          getVehiclesUrl = urlConfig$4[ctx.env].getVehiclesUrl;
          _context32.next = 6;
          return get("".concat(getVehiclesUrl, "?page_size=").concat(PAGE_SIZE, "&page=").concat(page), zod.z.object({
            count: zod.z.number(),
            results: zod.z.array(zod.z.object({
              id: zod.z.number(),
              manufacturer: zod.z.string(),
              model: zod.z.string(),
              year: zod.z.string(),
              plate: zod.z.string(),
              color: zod.z.string()
            }))
          }));

        case 6:
          _yield$get16 = _context32.sent;
          data = _yield$get16.data;
          return _context32.abrupt("return", {
            vehicles: data.results,
            totalPageCount: Math.ceil(data.count || 0 / PAGE_SIZE)
          });

        case 9:
        case "end":
          return _context32.stop();
      }
    }, _callee32);
  }));

  return function (_x54, _x55) {
    return _ref99.apply(this, arguments);
  };
}());
var getDriverRidesLinks = f$4.fetcher( /*#__PURE__*/function () {
  var _ref102 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(_ref100, _ref101) {
    var ctx, get, driverId, startDate, endDate, tracked, _urlConfig$4$ctx$env, driverUntrackedRidesUrl, driverTrackedRidesUrl, url, params, paramsString, _yield$get17, data;

    return _regeneratorRuntime.wrap(function _callee33$(_context33) {
      while (1) switch (_context33.prev = _context33.next) {
        case 0:
          ctx = _ref100.ctx, get = _ref100.get;
          driverId = _ref101.driverId, startDate = _ref101.startDate, endDate = _ref101.endDate, tracked = _ref101.tracked;

          if (!(driverId === "NO DRIVER ASSIGNED")) {
            _context33.next = 4;
            break;
          }

          return _context33.abrupt("return", []);

        case 4:
          _urlConfig$4$ctx$env = urlConfig$4[ctx.env], driverUntrackedRidesUrl = _urlConfig$4$ctx$env.driverUntrackedRidesUrl, driverTrackedRidesUrl = _urlConfig$4$ctx$env.driverTrackedRidesUrl;
          url = tracked ? driverTrackedRidesUrl : driverUntrackedRidesUrl;
          params = {
            driver_email: driverId,
            start_date: startDate.toISOString().split("T")[0],
            end_date: endDate.toISOString().split("T")[0]
          };
          paramsString = new URLSearchParams(params).toString();
          _context33.next = 10;
          return get("".concat(url, "?").concat(paramsString), zod.z.object({
            reservations: zod.z.array(zod.z.object({
              reservation_hashed_id: zod.z.string(),
              user_external_id: zod.z.string()
            }))
          }));

        case 10:
          _yield$get17 = _context33.sent;
          data = _yield$get17.data;
          return _context33.abrupt("return", data.reservations.map(function (result) {
            return {
              id: result.reservation_hashed_id,
              content: result.user_external_id
            };
          }));

        case 13:
        case "end":
          return _context33.stop();
      }
    }, _callee33);
  }));

  return function (_x56, _x57) {
    return _ref102.apply(this, arguments);
  };
}());
var createProviderQuery = f$4.combineFetchers({
  getDriversRides: getDriversRides,
  getRideTrackingSummary: getRideTrackingSummary,
  getVehicles: getVehicles,
  getDriverRidesLinks: getDriverRidesLinks
});
var urlConfig$3 = {
  staging: {
    locationUrl: "https://api-staging-internal.mozio.com/v2/locations"
  },
  production: {
    locationUrl: "https://api.mozio.com/v2/locations"
  }
};
var f$3 = new fetcher.FetcherClient({
  ctx: zod.z.object({
    env: envSchema
  }),
  headers: {
    lang: zod.z.string(),
    "api-key": zod.z.string()
  }
});
var locationSchema$1 = zod.z.object({
  display: zod.z.string().min(1),
  name: zod.z.string().min(1),
  value: zod.z.string().min(1),
  lat: zod.z.number(),
  lng: zod.z.number()
});
var queryAirports = f$3.fetcher( /*#__PURE__*/function () {
  var _ref105 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(_ref103, _ref104) {
    var ctx, get, query, locationUrl, _yield$get18, data;

    return _regeneratorRuntime.wrap(function _callee34$(_context34) {
      while (1) switch (_context34.prev = _context34.next) {
        case 0:
          ctx = _ref103.ctx, get = _ref103.get;
          query = _ref104.query;

          if (!(query.length < 3)) {
            _context34.next = 4;
            break;
          }

          return _context34.abrupt("return", []);

        case 4:
          locationUrl = urlConfig$3[ctx.env].locationUrl;
          _context34.next = 7;
          return get("".concat(locationUrl, "/airports/?query=").concat(query), zod.z.object({
            results: zod.z.array(locationSchema$1.passthrough())
          }));

        case 7:
          _yield$get18 = _context34.sent;
          data = _yield$get18.data;
          return _context34.abrupt("return", data.results.map(function (location) {
            return {
              displayText: location.display,
              name: location.name,
              value: location.value,
              lat: location.lat,
              lng: location.lng
            };
          }));

        case 10:
        case "end":
          return _context34.stop();
      }
    }, _callee34);
  }));

  return function (_x58, _x59) {
    return _ref105.apply(this, arguments);
  };
}());
var createLocationQuery = f$3.combineFetchers({
  queryAirports: queryAirports
});
var urlConfig$2 = {
  staging: {
    parkingUrl: "https://parking-staging.mozio.com/v1"
  },
  production: {
    parkingUrl: "https://parking-api.mozio.com/v1"
  }
};
var f$2 = new fetcher.FetcherClient({
  ctx: zod.z.object({
    env: envSchema
  }),
  headers: {
    lang: zod.z.string(),
    Authorization: zod.z.string(),
    "white-label-id": zod.z.number().optional(),
    "white-label-name": zod.z.string(),
    "partner-ref": zod.z.string(),
    hostname: zod.z.string(),
    "distinct-id": zod.z.union([zod.z.string(), zod.z.number()]).optional()
  }
});
var errorSchema = zod.z.object({
  code: zod.z.enum(["search_expired", "reservation_not_exist", "payment_error", "paymentintent_not_chargeable", "payment_information_missing", "invalid_coupon", "changes_not_allowed_cannot_cancel"]),
  message: zod.z.string()
});
var ERROR_CODES = {
  SEARCH_EXPIRED: "search_expired",
  RESERVATION_NOT_EXIST: "reservation_not_exist",
  PAYMENT_ERROR: "payment_error",
  PAYMENT_INTENT_NOT_CHARGEABLE: "paymentintent_not_chargeable",
  PAYMENT_INFORMATION_MISSING: "payment_information_missing",
  INVALID_COUPON: "invalid_coupon",
  CHANGES_NOT_ALLOWED_CANNOT_CANCEL: "changes_not_allowed_cannot_cancel"
};

var isExpectedError = function isExpectedError(code) {
  return Object.values(ERROR_CODES).includes(code);
};

var locationSchema = zod.z.object({
  value: zod.z.string(),
  name: zod.z.string(),
  lat: zod.z.number().nullable(),
  lng: zod.z.number().nullable()
});
var PARKING_TRANSFER_TYPE = {
  WALK: "WALK",
  SHUTTLE: "SHUTTLE",
  MEET_AND_GREET: "MEET_AND_GREET"
};
var PARKING_FEATURE_TYPE = {
  FREE_CANCELLATION: "FREE_CANCELLATION",
  COVERED: "COVERED",
  UNCOVERED: "UNCOVERED",
  ACCESSIBLE: "ACCESSIBLE",
  OPEN_24_7: "OPEN_24_7",
  CCTV: "CCTV",
  KEY_DROP_OFF: "KEY_DROP_OFF"
};
var searchResponseSchema = zod.z.object({
  search_id: zod.z.string(),
  more_coming: zod.z.boolean(),
  arrival_datetime_display: zod.z.preprocess(function (date) {
    return new Date(zod.z.string().parse(date));
  }, zod.z.date()),
  departure_datetime_display: zod.z.preprocess(function (date) {
    return new Date(zod.z.string().parse(date));
  }, zod.z.date()),
  location: locationSchema,
  search_context_hash: zod.z.string(),
  expires_at: zod.z.number(),
  results: zod.z.array(zod.z.object({
    result_id: zod.z.string(),
    provider: zod.z.object({
      id: zod.z.string(),
      name: zod.z.string()
    }),
    location: locationSchema,
    name: zod.z.string(),
    description: zod.z.string(),
    price: zod.z.object({
      amount: zod.z.string(),
      currency_code: zod.z.string()
    }),
    image_url: zod.z.string().url().nullable().optional(),
    logo_url: zod.z.string().url().nullable().optional(),
    detailed_instructions_html: zod.z.string().nullable(),
    basic_instructions_html: zod.z.string(),
    cancellation: zod.z.object({
      notice_in_hours: zod.z.number(),
      refund_percentage: zod.z.number()
    }).optional(),
    // TODO: could be undefined?
    airport_transfer_summary: zod.z.object({
      id: zod.z.string(),
      name: zod.z.string(),
      distance_meter: zod.z.number().nullable(),
      type: zod.z.enum(["WALK", "SHUTTLE", "MEET_AND_GREET"]),
      descriptions: zod.z.array(zod.z.string())
    }),
    features: zod.z.array(zod.z.object({
      id: zod.z.string(),
      type: zod.z.enum(["FREE_CANCELLATION", "COVERED", "UNCOVERED", "ACCESSIBLE", "OPEN_24_7", "CCTV", "KEY_DROP_OFF"]),
      name: zod.z.string(),
      description: zod.z.string()
    }))
  }))
});

var mapLocation = function mapLocation(location) {
  var _location$lat, _location$lng;

  return {
    value: location.value,
    name: location.name,
    lat: (_location$lat = location.lat) !== null && _location$lat !== void 0 ? _location$lat : void 0,
    lng: (_location$lng = location.lng) !== null && _location$lng !== void 0 ? _location$lng : void 0
  };
};

var mapParkingSearchResult = function mapParkingSearchResult(result) {
  var _result$image_url, _result$logo_url, _result$detailed_inst, _result$airport_trans;

  return {
    id: result.result_id,
    name: result.name,
    price: {
      amount: Number.parseFloat(result.price.amount),
      currency: result.price.currency_code
    },
    location: mapLocation(result.location),
    imageUrl: (_result$image_url = result.image_url) !== null && _result$image_url !== void 0 ? _result$image_url : void 0,
    logoUrl: (_result$logo_url = result.logo_url) !== null && _result$logo_url !== void 0 ? _result$logo_url : void 0,
    providerId: result.provider.id,
    resultId: result.result_id,
    description: result.description,
    basicInstructionsHtml: result.basic_instructions_html,
    detailedInstructionsHtml: (_result$detailed_inst = result.detailed_instructions_html) !== null && _result$detailed_inst !== void 0 ? _result$detailed_inst : void 0,
    airportTransferSummary: _objectSpread(_objectSpread({}, result.airport_transfer_summary), {}, {
      // NOTE: if we don't know the distance, we consider it infinite so it's sorted last
      distanceMeter: (_result$airport_trans = result.airport_transfer_summary.distance_meter) !== null && _result$airport_trans !== void 0 ? _result$airport_trans : Number.POSITIVE_INFINITY
    }),
    features: result.features
  };
};

var initiateSearch = f$2.fetcher( /*#__PURE__*/function () {
  var _ref108 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(_ref106, _ref107) {
    var ctx, post, arrivalDateTime, departureDateTime, location, partnerRef, parkingUrl, _yield$post12, data;

    return _regeneratorRuntime.wrap(function _callee35$(_context35) {
      while (1) switch (_context35.prev = _context35.next) {
        case 0:
          ctx = _ref106.ctx, post = _ref106.post;
          arrivalDateTime = _ref107.arrivalDateTime, departureDateTime = _ref107.departureDateTime, location = _ref107.location, partnerRef = _ref107.partnerRef;
          parkingUrl = urlConfig$2[ctx.env].parkingUrl;
          _context35.next = 5;
          return post("".concat(parkingUrl, "/search"), searchResponseSchema, {
            arrival_datetime: arrivalDateTime,
            departure_datetime: departureDateTime,
            location: locationSchema.parse(location),
            ref: partnerRef
          });

        case 5:
          _yield$post12 = _context35.sent;
          data = _yield$post12.data;
          return _context35.abrupt("return", {
            searchId: data.search_id,
            location: mapLocation(data.location),
            arrivalDateTime: data.arrival_datetime_display,
            departureDateTime: data.departure_datetime_display,
            results: [],
            searchContextHash: data.search_context_hash,
            moreComing: data.more_coming,
            expiresAt: data.expires_at
          });

        case 8:
        case "end":
          return _context35.stop();
      }
    }, _callee35);
  }));

  return function (_x60, _x61) {
    return _ref108.apply(this, arguments);
  };
}());
var getSearchResults = f$2.fetcher( /*#__PURE__*/function () {
  var _ref111 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(_ref109, _ref110) {
    var ctx, get, searchId, parkingUrl, _yield$get19, data;

    return _regeneratorRuntime.wrap(function _callee36$(_context36) {
      while (1) switch (_context36.prev = _context36.next) {
        case 0:
          ctx = _ref109.ctx, get = _ref109.get;
          searchId = _ref110.searchId;
          parkingUrl = urlConfig$2[ctx.env].parkingUrl;
          _context36.next = 5;
          return get("".concat(parkingUrl, "/search/").concat(searchId, "/poll"), searchResponseSchema);

        case 5:
          _yield$get19 = _context36.sent;
          data = _yield$get19.data;
          return _context36.abrupt("return", {
            searchId: data.search_id,
            location: mapLocation(data.location),
            arrivalDateTime: data.arrival_datetime_display,
            departureDateTime: data.departure_datetime_display,
            results: data.results.map(function (result) {
              return mapParkingSearchResult(result);
            }),
            searchContextHash: data.search_context_hash,
            moreComing: data.more_coming,
            expiresAt: data.expires_at
          });

        case 8:
        case "end":
          return _context36.stop();
      }
    }, _callee36);
  }));

  return function (_x62, _x63) {
    return _ref111.apply(this, arguments);
  };
}());
var getSearchResult = f$2.fetcher( /*#__PURE__*/function () {
  var _ref114 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(_ref112, _ref113) {
    var ctx, get, searchId, resultId, providerId, parkingUrl, _yield$get20, data;

    return _regeneratorRuntime.wrap(function _callee37$(_context37) {
      while (1) switch (_context37.prev = _context37.next) {
        case 0:
          ctx = _ref112.ctx, get = _ref112.get;
          searchId = _ref113.searchId, resultId = _ref113.resultId, providerId = _ref113.providerId;
          parkingUrl = urlConfig$2[ctx.env].parkingUrl;
          _context37.next = 5;
          return get("".concat(parkingUrl, "/search/").concat(searchId, "/").concat(resultId, "?provider_id=").concat(providerId), zod.z.union([errorSchema, searchResponseSchema]));

        case 5:
          _yield$get20 = _context37.sent;
          data = _yield$get20.data;

          if (!("code" in data && isExpectedError(data.code))) {
            _context37.next = 9;
            break;
          }

          return _context37.abrupt("return", {
            error: data.code,
            message: data.message
          });

        case 9:
          if (!("search_id" in data)) {
            _context37.next = 11;
            break;
          }

          return _context37.abrupt("return", {
            searchId: data.search_id,
            results: data.results.map(function (result) {
              return mapParkingSearchResult(result);
            }),
            arrivalDateTime: data.arrival_datetime_display,
            departureDateTime: data.departure_datetime_display,
            location: mapLocation(data.location),
            searchContextHash: data.search_context_hash,
            moreComing: data.more_coming,
            expiresAt: data.expires_at
          });

        case 11:
          throw new Error("An unexpected error has occurred. Error: ".concat(data.code));

        case 12:
        case "end":
          return _context37.stop();
      }
    }, _callee37);
  }));

  return function (_x64, _x65) {
    return _ref114.apply(this, arguments);
  };
}());
var updateSearchResult = f$2.fetcher( /*#__PURE__*/function () {
  var _ref117 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(_ref115, _ref116) {
    var ctx, patch, searchId, resultId, providerId, arrivalDateTime, departureDateTime, location, parkingUrl, _yield$patch2, data;

    return _regeneratorRuntime.wrap(function _callee38$(_context38) {
      while (1) switch (_context38.prev = _context38.next) {
        case 0:
          ctx = _ref115.ctx, patch = _ref115.patch;
          searchId = _ref116.searchId, resultId = _ref116.resultId, providerId = _ref116.providerId, arrivalDateTime = _ref116.arrivalDateTime, departureDateTime = _ref116.departureDateTime, location = _ref116.location;
          parkingUrl = urlConfig$2[ctx.env].parkingUrl;
          _context38.next = 5;
          return patch("".concat(parkingUrl, "/search/").concat(searchId, "/").concat(resultId, "?provider_id=").concat(providerId), zod.z.union([errorSchema, searchResponseSchema]), {
            arrival_datetime: arrivalDateTime,
            departure_datetime: departureDateTime,
            location: location
          });

        case 5:
          _yield$patch2 = _context38.sent;
          data = _yield$patch2.data;

          if (!("code" in data && isExpectedError(data.code))) {
            _context38.next = 9;
            break;
          }

          return _context38.abrupt("return", {
            error: data.code,
            message: data.message
          });

        case 9:
          if (!("search_id" in data)) {
            _context38.next = 11;
            break;
          }

          return _context38.abrupt("return", {
            searchId: data.search_id,
            results: data.results.map(function (result) {
              return mapParkingSearchResult(result);
            }),
            arrivalDateTime: data.arrival_datetime_display,
            departureDateTime: data.departure_datetime_display,
            location: mapLocation(data.location),
            searchContextHash: data.search_context_hash,
            moreComing: data.more_coming,
            expiresAt: data.expires_at
          });

        case 11:
          throw new Error("An unexpected error has occurred. Error: ".concat(data.code));

        case 12:
        case "end":
          return _context38.stop();
      }
    }, _callee38);
  }));

  return function (_x66, _x67) {
    return _ref117.apply(this, arguments);
  };
}());
var paymentIntentResultSchema = zod.z.object({
  paymentintent_id: zod.z.string(),
  client_secret: zod.z.string()
});

var createOrUpdatePaymentIntent = /*#__PURE__*/function () {
  var _ref119 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(_ref118) {
    var post, currency, amount, parkingUrl, resultId, searchId, paymentIntentId, _yield$post13, data;

    return _regeneratorRuntime.wrap(function _callee39$(_context39) {
      while (1) switch (_context39.prev = _context39.next) {
        case 0:
          post = _ref118.post, currency = _ref118.currency, amount = _ref118.amount, parkingUrl = _ref118.parkingUrl, resultId = _ref118.resultId, searchId = _ref118.searchId, paymentIntentId = _ref118.paymentIntentId;
          _context39.next = 3;
          return post("".concat(parkingUrl, "/payment-intent/").concat(paymentIntentId), zod.z.union([paymentIntentResultSchema, errorSchema]), {
            result_id: resultId,
            search_id: searchId,
            currency: currency,
            amount: amount
          });

        case 3:
          _yield$post13 = _context39.sent;
          data = _yield$post13.data;

          if (!("code" in data)) {
            _context39.next = 7;
            break;
          }

          return _context39.abrupt("return", {
            error: data.code,
            message: data.message
          });

        case 7:
          return _context39.abrupt("return", {
            paymentIntentId: data.paymentintent_id,
            clientSecret: data.client_secret
          });

        case 8:
        case "end":
          return _context39.stop();
      }
    }, _callee39);
  }));

  return function createOrUpdatePaymentIntent(_x68) {
    return _ref119.apply(this, arguments);
  };
}();

var calculatePricingResultSchema = zod.z.object({
  currency: zod.z.string(),
  coupon_code: zod.z.string(),
  coupon_discount: zod.z.object({
    display: zod.z.string(),
    value: zod.z.string()
  }),
  original_price: zod.z.object({
    display: zod.z.string(),
    value: zod.z.string()
  }),
  final_price: zod.z.object({
    display: zod.z.string(),
    value: zod.z.string(),
    smallest_currency_unit: zod.z.number()
  }),
  total_price: zod.z.object({
    display: zod.z.string(),
    value: zod.z.string()
  }),
  platform_fee: zod.z.object({
    display: zod.z.string(),
    value: zod.z.string()
  })
});

var mapPricingResult = function mapPricingResult(result) {
  return {
    currency: result.currency,
    couponCode: result.coupon_code,
    couponDiscount: {
      display: result.coupon_discount.display,
      value: result.coupon_discount.value
    },
    originalPrice: {
      display: result.original_price.display,
      value: result.original_price.value
    },
    finalPrice: {
      display: result.final_price.display,
      value: result.final_price.value,
      smallestCurrencyUnit: result.final_price.smallest_currency_unit
    },
    totalPrice: {
      display: result.total_price.display,
      value: result.total_price.value
    }
  };
};

var calculatePricing = f$2.fetcher( /*#__PURE__*/function () {
  var _ref122 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(_ref120, _ref121) {
    var ctx, post, searchId, resultId, providerId, couponCode, paymentIntentId, parkingUrl, _yield$post14, data, result, invalidCoupon, _yield$post16, data2, paymentIntentData;

    return _regeneratorRuntime.wrap(function _callee40$(_context40) {
      while (1) switch (_context40.prev = _context40.next) {
        case 0:
          ctx = _ref120.ctx, post = _ref120.post;
          searchId = _ref121.searchId, resultId = _ref121.resultId, providerId = _ref121.providerId, couponCode = _ref121.couponCode, paymentIntentId = _ref121.paymentIntentId;
          parkingUrl = urlConfig$2[ctx.env].parkingUrl;
          _context40.next = 5;
          return post("".concat(parkingUrl, "/pricing"), zod.z.union([calculatePricingResultSchema, errorSchema]), {
            search_id: searchId,
            result_id: resultId,
            provider_id: providerId,
            coupon_code: couponCode
          });

        case 5:
          _yield$post14 = _context40.sent;
          data = _yield$post14.data;
          result = data;
          invalidCoupon = false;

          if (!("code" in result && isExpectedError(result.code))) {
            _context40.next = 20;
            break;
          }

          if (!(result.code !== ERROR_CODES.INVALID_COUPON)) {
            _context40.next = 12;
            break;
          }

          return _context40.abrupt("return", {
            error: result.code,
            message: result.message
          });

        case 12:
          invalidCoupon = true;
          _context40.next = 15;
          return post("".concat(parkingUrl, "/pricing"), zod.z.union([calculatePricingResultSchema, errorSchema]), {
            search_id: searchId,
            result_id: resultId,
            provider_id: providerId
          });

        case 15:
          _yield$post16 = _context40.sent;
          data2 = _yield$post16.data;
          result = data2;

          if (!("code" in result && isExpectedError(result.code))) {
            _context40.next = 20;
            break;
          }

          return _context40.abrupt("return", {
            error: result.code,
            message: result.message
          });

        case 20:
          if (!("currency" in result)) {
            _context40.next = 28;
            break;
          }

          if (!(result.final_price.smallest_currency_unit > 0)) {
            _context40.next = 27;
            break;
          }

          _context40.next = 24;
          return createOrUpdatePaymentIntent({
            post: post,
            currency: result.currency,
            amount: Number.parseFloat(result.final_price.value),
            parkingUrl: parkingUrl,
            resultId: resultId,
            searchId: searchId,
            paymentIntentId: paymentIntentId
          });

        case 24:
          paymentIntentData = _context40.sent;

          if (!("error" in paymentIntentData)) {
            _context40.next = 27;
            break;
          }

          return _context40.abrupt("return", {
            error: paymentIntentData.error,
            message: paymentIntentData.message
          });

        case 27:
          return _context40.abrupt("return", _objectSpread({
            invalidCoupon: invalidCoupon,
            paymentIntentId: paymentIntentData && "paymentIntentId" in paymentIntentData ? paymentIntentData.paymentIntentId : void 0,
            clientSecret: paymentIntentData && "clientSecret" in paymentIntentData ? paymentIntentData.clientSecret : void 0
          }, mapPricingResult(result)));

        case 28:
          throw new Error("An unexpected error has occurred. Error: ".concat(result.code));

        case 29:
        case "end":
          return _context40.stop();
      }
    }, _callee40);
  }));

  return function (_x69, _x70) {
    return _ref122.apply(this, arguments);
  };
}());
var createReservationResponseSchema = zod.z.object({
  status: zod.z.enum(["pending", "paid", "confirmed", "cancelled", "completed"]).nullable(),
  reservations: zod.z.array(zod.z.object({
    id: zod.z.string(),
    result_id: zod.z.string(),
    search_id: zod.z.string()
  }))
});
var PARKING_STATUS_TYPE = {
  PENDING: "pending",
  PAID: "paid",
  CONFIRMED: "confirmed",
  CANCELLED: "cancelled",
  COMPLETED: "completed"
};
var createReservation = f$2.fetcher( /*#__PURE__*/function () {
  var _ref125 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41(_ref123, _ref124) {
    var _departureFlight$orig, _arrivalFlight$destin;

    var ctx, post, resultId, searchId, providerId, searchContextHash, vehicle, customer, passengerCount, travelReason, couponCode, paymentIntentId, departureFlight, arrivalFlight, parkingUrl, _yield$post17, data, _data$reservations$;

    return _regeneratorRuntime.wrap(function _callee41$(_context41) {
      while (1) switch (_context41.prev = _context41.next) {
        case 0:
          ctx = _ref123.ctx, post = _ref123.post;
          resultId = _ref124.resultId, searchId = _ref124.searchId, providerId = _ref124.providerId, searchContextHash = _ref124.searchContextHash, vehicle = _ref124.vehicle, customer = _ref124.customer, passengerCount = _ref124.passengerCount, travelReason = _ref124.travelReason, couponCode = _ref124.couponCode, paymentIntentId = _ref124.paymentIntentId, departureFlight = _ref124.departureFlight, arrivalFlight = _ref124.arrivalFlight;
          parkingUrl = urlConfig$2[ctx.env].parkingUrl;
          _context41.next = 5;
          return post("".concat(parkingUrl, "/reservations"), zod.z.union([createReservationResponseSchema, errorSchema]), {
            result_id: resultId,
            search_id: searchId,
            provider_id: providerId,
            search_context_hash: searchContextHash,
            vehicle: _objectSpread(_objectSpread({}, vehicle), {}, {
              colour: vehicle.color,
              // cspell:disable-line
              registration_number: vehicle.registrationNumber
            }),
            customer: {
              // TODO: Validate with BE what is this field
              title: "",
              first_name: customer.firstName,
              last_name: customer.lastName,
              email: customer.email,
              phone: customer.phone
            },
            voyages: [departureFlight.flightCode && {
              code: departureFlight.flightCode,
              terminal: (_departureFlight$orig = departureFlight.originTerminal) !== null && _departureFlight$orig !== void 0 ? _departureFlight$orig : "0",
              direction: "outbound"
            }, arrivalFlight.flightCode && {
              code: arrivalFlight.flightCode,
              terminal: (_arrivalFlight$destin = arrivalFlight.destinationTerminal) !== null && _arrivalFlight$destin !== void 0 ? _arrivalFlight$destin : "0",
              direction: "inbound"
            }].filter(Boolean),
            num_passengers: passengerCount ? Number.parseFloat(passengerCount) : void 0,
            travel_reason: travelReason,
            coupon_code: couponCode,
            paymentintent_id: paymentIntentId
          });

        case 5:
          _yield$post17 = _context41.sent;
          data = _yield$post17.data;

          if (!("code" in data && isExpectedError(data.code))) {
            _context41.next = 9;
            break;
          }

          return _context41.abrupt("return", {
            error: data.code,
            message: data.message
          });

        case 9:
          if (!("status" in data)) {
            _context41.next = 11;
            break;
          }

          return _context41.abrupt("return", {
            id: data === null || data === void 0 || (_data$reservations$ = data.reservations[0]) === null || _data$reservations$ === void 0 ? void 0 : _data$reservations$.id
          });

        case 11:
          throw new Error("An unexpected error has occurred. Error: ".concat(data.code));

        case 12:
        case "end":
          return _context41.stop();
      }
    }, _callee41);
  }));

  return function (_x71, _x72) {
    return _ref125.apply(this, arguments);
  };
}());
var getReservationResponseSchema = zod.z.object({
  id: zod.z.string(),
  customer: zod.z.object({
    first_name: zod.z.string(),
    email: zod.z.string()
  }),
  carpark_name: zod.z.string(),
  search_context: zod.z.object({
    arrival_datetime: zod.z.string(),
    departure_datetime: zod.z.string(),
    location: zod.z.object({
      name: zod.z.string()
    })
  }),
  payment: zod.z.object({
    total_price: zod.z.string(),
    final_price: zod.z.string(),
    discounts: zod.z.object({
      coupon: zod.z.object({
        discount_type: zod.z.enum(["PERCENTAGE", "FIXED"]),
        percentage_amount: zod.z.number(),
        amount: zod.z.string()
      }).optional().nullable()
    }).optional().nullable(),
    coupon_code: zod.z.string().optional().nullable()
  }),
  status: zod.z.enum(["pending", "paid", "confirmed", "cancelled", "completed"]),
  cancellation: zod.z.object({
    notice_in_hours: zod.z.number(),
    refund_percentage: zod.z.number()
  })
});
var getReservation = f$2.fetcher( /*#__PURE__*/function () {
  var _ref128 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(_ref126, _ref127) {
    var ctx, get, reservationId, parkingUrl, _yield$get21, data;

    return _regeneratorRuntime.wrap(function _callee42$(_context42) {
      while (1) switch (_context42.prev = _context42.next) {
        case 0:
          ctx = _ref126.ctx, get = _ref126.get;
          reservationId = _ref127.reservationId;
          parkingUrl = urlConfig$2[ctx.env].parkingUrl;
          _context42.next = 5;
          return get("".concat(parkingUrl, "/reservations/").concat(reservationId), zod.z.union([getReservationResponseSchema, errorSchema]));

        case 5:
          _yield$get21 = _context42.sent;
          data = _yield$get21.data;

          if (!("code" in data && isExpectedError(data.code))) {
            _context42.next = 9;
            break;
          }

          return _context42.abrupt("return", {
            error: data.code,
            message: data.message
          });

        case 9:
          if (!("id" in data)) {
            _context42.next = 11;
            break;
          }

          return _context42.abrupt("return", mapReservation(data));

        case 11:
          throw new Error("An unexpected error has occurred. Error: ".concat(data.code));

        case 12:
        case "end":
          return _context42.stop();
      }
    }, _callee42);
  }));

  return function (_x73, _x74) {
    return _ref128.apply(this, arguments);
  };
}());
var getReservations = f$2.fetcher( /*#__PURE__*/function () {
  var _ref131 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(_ref129, _ref130) {
    var ctx, get, email, parkingUrl, _yield$get22, data;

    return _regeneratorRuntime.wrap(function _callee43$(_context43) {
      while (1) switch (_context43.prev = _context43.next) {
        case 0:
          ctx = _ref129.ctx, get = _ref129.get;
          email = _ref130.email;
          parkingUrl = urlConfig$2[ctx.env].parkingUrl;
          _context43.next = 5;
          return get("".concat(parkingUrl, "/reservations?email=").concat(encodeURIComponent(email)), zod.z.array(getReservationResponseSchema).or(errorSchema));

        case 5:
          _yield$get22 = _context43.sent;
          data = _yield$get22.data;

          if (!("code" in data && isExpectedError(data.code))) {
            _context43.next = 9;
            break;
          }

          return _context43.abrupt("return", {
            error: data.code,
            message: data.message
          });

        case 9:
          if (!Array.isArray(data)) {
            _context43.next = 11;
            break;
          }

          return _context43.abrupt("return", data.map(function (reservation) {
            return mapReservation(reservation);
          }));

        case 11:
          throw new Error("An unexpected error has occurred. Error: ".concat(data.code));

        case 12:
        case "end":
          return _context43.stop();
      }
    }, _callee43);
  }));

  return function (_x75, _x76) {
    return _ref131.apply(this, arguments);
  };
}());
var cancelReservation = f$2.fetcher( /*#__PURE__*/function () {
  var _ref134 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(_ref132, _ref133) {
    var ctx, _delete, reservationId, reason, parkingUrl, _yield$_delete, data;

    return _regeneratorRuntime.wrap(function _callee44$(_context44) {
      while (1) switch (_context44.prev = _context44.next) {
        case 0:
          ctx = _ref132.ctx, _delete = _ref132.delete;
          reservationId = _ref133.reservationId, reason = _ref133.reason;
          parkingUrl = urlConfig$2[ctx.env].parkingUrl;
          _context44.next = 5;
          return _delete("".concat(parkingUrl, "/reservations/").concat(reservationId, "/"), zod.z.union([getReservationResponseSchema, errorSchema]), {
            reason: reason
          }, {
            headers: {
              "Content-Type": "application/json;charset=utf-8"
            }
          });

        case 5:
          _yield$_delete = _context44.sent;
          data = _yield$_delete.data;

          if (!("code" in data && isExpectedError(data.code))) {
            _context44.next = 9;
            break;
          }

          return _context44.abrupt("return", {
            error: data.code,
            message: data.message
          });

        case 9:
          if (!("id" in data)) {
            _context44.next = 11;
            break;
          }

          return _context44.abrupt("return", {
            id: data.id,
            status: data.status
          });

        case 11:
          throw new Error("An unexpected error has occurred. Error: ".concat(data.code));

        case 12:
        case "end":
          return _context44.stop();
      }
    }, _callee44);
  }));

  return function (_x77, _x78) {
    return _ref134.apply(this, arguments);
  };
}());
var resendNotificationResponseSchema = zod.z.object({
  customer_email: zod.z.string()
});
var resendNotification = f$2.fetcher( /*#__PURE__*/function () {
  var _ref137 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(_ref135, _ref136) {
    var ctx, get, reservationId, parkingUrl, _yield$get23, data;

    return _regeneratorRuntime.wrap(function _callee45$(_context45) {
      while (1) switch (_context45.prev = _context45.next) {
        case 0:
          ctx = _ref135.ctx, get = _ref135.get;
          reservationId = _ref136.reservationId;
          parkingUrl = urlConfig$2[ctx.env].parkingUrl;
          _context45.next = 5;
          return get("".concat(parkingUrl, "/notifications/").concat(reservationId), zod.z.union([resendNotificationResponseSchema, errorSchema]));

        case 5:
          _yield$get23 = _context45.sent;
          data = _yield$get23.data;

          if (!("code" in data && isExpectedError(data.code))) {
            _context45.next = 9;
            break;
          }

          return _context45.abrupt("return", {
            error: data.code,
            message: data.message
          });

        case 9:
          if (!("customer_email" in data)) {
            _context45.next = 11;
            break;
          }

          return _context45.abrupt("return", {
            customerEmail: data.customer_email
          });

        case 11:
          throw new Error("An unexpected error has occurred. Error: ".concat(data.code));

        case 12:
        case "end":
          return _context45.stop();
      }
    }, _callee45);
  }));

  return function (_x79, _x80) {
    return _ref137.apply(this, arguments);
  };
}());

var mapReservation = function mapReservation(reservation) {
  var _reservation$payment$;

  return {
    id: reservation.id,
    customer: {
      firstName: reservation.customer.first_name,
      email: reservation.customer.email
    },
    parkingName: reservation.carpark_name,
    arrivalDateTime: reservation.search_context.arrival_datetime.slice(0, -1),
    departureDateTime: reservation.search_context.departure_datetime.slice(0, -1),
    location: reservation.search_context.location.name,
    payment: {
      totalPrice: reservation.payment.total_price,
      finalPrice: reservation.payment.final_price,
      coupon: reservation.payment.coupon_code && (_reservation$payment$ = reservation.payment.discounts) !== null && _reservation$payment$ !== void 0 && (_reservation$payment$ = _reservation$payment$.coupon) !== null && _reservation$payment$ !== void 0 && _reservation$payment$.amount ? {
        code: reservation.payment.coupon_code,
        discount: reservation.payment.discounts.coupon.amount
      } : void 0
    },
    status: reservation.status,
    cancellation: {
      noticeInHours: reservation.cancellation.notice_in_hours,
      refundPercentage: reservation.cancellation.refund_percentage
    }
  };
};

var createParkingQuery = f$2.combineFetchers({
  getSearchResults: getSearchResults,
  getSearchResult: getSearchResult,
  initiateSearch: initiateSearch,
  updateSearchResult: updateSearchResult,
  calculatePricing: calculatePricing,
  createReservation: createReservation,
  getReservation: getReservation,
  getReservations: getReservations,
  cancelReservation: cancelReservation,
  resendNotification: resendNotification
});
var urlConfig$1 = {
  staging: {
    flightsUrl: "https://api-staging-internal.mozio.com/v2/flights/"
  },
  production: {
    flightsUrl: "https://api.mozio.com/v2/flights"
  }
};
var f$1 = new fetcher.FetcherClient({
  ctx: zod.z.object({
    env: envSchema
  }),
  headers: {
    lang: zod.z.string(),
    "api-key": zod.z.string()
  }
});

var dateToFormattedISO = function dateToFormattedISO(date) {
  var offset = date.getTimezoneOffset() * 6e4;
  return new Date(date.valueOf() - offset).toISOString().slice(0, -1);
};

var FLIGHT_DIRECTION = {
  ARRIVAL: "arr",
  DEPARTURE: "dep"
};
var flightSchema = zod.z.object({
  destination: zod.z.string(),
  airline: zod.z.object({
    airline_name: zod.z.string(),
    airline_code: zod.z.string()
  }),
  flight_code: zod.z.string(),
  flight_number: zod.z.string(),
  datetime: zod.z.string(),
  origin: zod.z.string(),
  time: zod.z.string(),
  origin_terminal: zod.z.string().nullable(),
  destination_terminal: zod.z.string().nullable()
});
var queryFlights = f$1.fetcher( /*#__PURE__*/function () {
  var _ref140 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46(_ref138, _ref139) {
    var ctx, get, airlineCode, airportCode, flightNumber, flightDirection, dateTime, flightsUrl, params, paramsString, _yield$get24, data;

    return _regeneratorRuntime.wrap(function _callee46$(_context46) {
      while (1) switch (_context46.prev = _context46.next) {
        case 0:
          ctx = _ref138.ctx, get = _ref138.get;
          airlineCode = _ref139.airlineCode, airportCode = _ref139.airportCode, flightNumber = _ref139.flightNumber, flightDirection = _ref139.flightDirection, dateTime = _ref139.dateTime;
          flightsUrl = urlConfig$1[ctx.env].flightsUrl;

          if (airlineCode) {
            _context46.next = 5;
            break;
          }

          return _context46.abrupt("return", []);

        case 5:
          params = _objectSpread(_objectSpread({
            airline_code: airlineCode,
            airport_code: airportCode,
            flight_direction: flightDirection
          }, dateTime ? {
            pickup_datetime: dateToFormattedISO(dateTime)
          } : {}), flightNumber ? {
            flight_number: flightNumber
          } : {});
          paramsString = new URLSearchParams(params).toString();
          _context46.next = 9;
          return get("".concat(flightsUrl, "?").concat(paramsString), zod.z.object({
            flights: zod.z.array(flightSchema)
          }));

        case 9:
          _yield$get24 = _context46.sent;
          data = _yield$get24.data;
          return _context46.abrupt("return", data.flights.map(function (flight) {
            var _flight$origin_termin, _flight$destination_t;

            var airline = flight.airline,
                flight_code = flight.flight_code,
                flight_number = flight.flight_number,
                rest = _objectWithoutProperties(flight, _excluded4);

            return _objectSpread(_objectSpread({}, rest), {}, {
              airlineCode: airline === null || airline === void 0 ? void 0 : airline.airline_code,
              airlineName: airline === null || airline === void 0 ? void 0 : airline.airline_name,
              flightCode: flight_code,
              flightNumber: flight_number,
              flightDateTime: new Date(flight.datetime),
              originTerminal: (_flight$origin_termin = flight.origin_terminal) !== null && _flight$origin_termin !== void 0 ? _flight$origin_termin : void 0,
              destinationTerminal: (_flight$destination_t = flight.destination_terminal) !== null && _flight$destination_t !== void 0 ? _flight$destination_t : void 0
            });
          }));

        case 12:
        case "end":
          return _context46.stop();
      }
    }, _callee46);
  }));

  return function (_x81, _x82) {
    return _ref140.apply(this, arguments);
  };
}());
var createFlightQuery = f$1.combineFetchers({
  queryFlights: queryFlights
});
var urlConfig = {
  staging: {
    travelAgentUrl: "https://api-staging-internal.mozio.com/v2/travel_agent/"
  },
  production: {
    travelAgentUrl: "https://api.mozio.com/v2/travel_agent/"
  }
};
var f = new fetcher.FetcherClient({
  ctx: zod.z.object({
    env: envSchema
  }),
  headers: {
    "api-key": zod.z.string(),
    "Content-Type": zod.z.string(),
    Authorization: zod.z.string().optional()
  }
});
var travelAgentSchema = zod.z.union([zod.z.object({
  company: zod.z.object({
    name: zod.z.string(),
    payout_to_master: zod.z.boolean()
  }),
  tax_id: zod.z.string().optional(),
  commission: zod.z.number(),
  commission_percentage: zod.z.number(),
  currency: zod.z.string(),
  iata_code: zod.z.string().optional().nullable(),
  abta_atol_code: zod.z.string().optional(),
  trade_id: zod.z.string().optional(),
  travel_agency_website: zod.z.string().optional(),
  travel_agency_social_link: zod.z.string().optional(),
  paypal_accounts: zod.z.array(zod.z.object({
    account_id: zod.z.number(),
    paypal_email: zod.z.string()
  })).optional(),
  position: zod.z.number()
}), authErrorSchema]);
var getTravelAgent = f.fetcher( /*#__PURE__*/function () {
  var _ref142 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47(_ref141) {
    var _data$paypal_accounts;

    var ctx, get, travelAgentUrl, _yield$get25, data;

    return _regeneratorRuntime.wrap(function _callee47$(_context47) {
      while (1) switch (_context47.prev = _context47.next) {
        case 0:
          ctx = _ref141.ctx, get = _ref141.get;
          travelAgentUrl = urlConfig[ctx.env].travelAgentUrl;
          _context47.next = 4;
          return get(travelAgentUrl, travelAgentSchema);

        case 4:
          _yield$get25 = _context47.sent;
          data = _yield$get25.data;

          if (!("code" in data)) {
            _context47.next = 8;
            break;
          }

          throw new AuthError();

        case 8:
          return _context47.abrupt("return", {
            company: {
              name: data.company.name,
              payoutToMaster: data.company.payout_to_master
            },
            taxId: data.tax_id,
            commissionType: data.commission_percentage > 0 ? "percentage" : "fixed",
            commissionFixed: data.commission,
            commissionPercentage: data.commission_percentage,
            currency: data.currency,
            iataCode: data.iata_code,
            abtaAtolCode: data.abta_atol_code,
            tradeId: data.trade_id,
            travelAgencyWebsite: data.travel_agency_website,
            travelAgencySocialLink: data.travel_agency_social_link,
            paypalAccounts: (_data$paypal_accounts = data.paypal_accounts) === null || _data$paypal_accounts === void 0 ? void 0 : _data$paypal_accounts.map(function (paypalAccount) {
              return {
                accountId: paypalAccount.account_id,
                paypalEmail: paypalAccount.paypal_email
              };
            }),
            position: data.position
          });

        case 9:
        case "end":
          return _context47.stop();
      }
    }, _callee47);
  }));

  return function (_x83) {
    return _ref142.apply(this, arguments);
  };
}());
var customerProfileSchema = zod.z.object({
  id: zod.z.number(),
  profile_name: zod.z.string().min(1),
  first_name: zod.z.string().min(1),
  last_name: zod.z.string().min(1),
  email: zod.z.string().min(1),
  country_code: zod.z.string().min(1),
  country_code_name: zod.z.string().min(1),
  phone_number_national: zod.z.string().min(1),
  phone_number: zod.z.string().min(1)
});
var customerProfileResponseSchema = zod.z.union([zod.z.object({
  count: zod.z.number(),
  next: zod.z.string().nullable(),
  previous: zod.z.string().nullable(),
  results: zod.z.array(customerProfileSchema)
}), authErrorSchema]);
var getCustomerProfiles = f.fetcher( /*#__PURE__*/function () {
  var _ref145 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48(_ref143, _ref144) {
    var ctx, get, page, pageSize, travelAgentUrl, params, paramsString, _yield$get26, data;

    return _regeneratorRuntime.wrap(function _callee48$(_context48) {
      while (1) switch (_context48.prev = _context48.next) {
        case 0:
          ctx = _ref143.ctx, get = _ref143.get;
          page = _ref144.page, pageSize = _ref144.pageSize;
          travelAgentUrl = urlConfig[ctx.env].travelAgentUrl;
          params = _objectSpread(_objectSpread({}, page ? {
            page: page.toString()
          } : {}), pageSize ? {
            page_size: pageSize.toString()
          } : {});
          paramsString = new URLSearchParams(params).toString();
          _context48.next = 7;
          return get("".concat(travelAgentUrl, "profiles/?").concat(paramsString), customerProfileResponseSchema);

        case 7:
          _yield$get26 = _context48.sent;
          data = _yield$get26.data;

          if (!("code" in data)) {
            _context48.next = 11;
            break;
          }

          throw new AuthError();

        case 11:
          return _context48.abrupt("return", {
            count: data.count,
            next: data.next,
            previous: data.previous,
            results: data.results.map(function (result) {
              return {
                id: result.id,
                profileName: result.profile_name,
                firstName: result.first_name,
                lastName: result.last_name,
                email: result.email,
                countryCode: result.country_code,
                countryCodeName: result.country_code_name,
                phoneNumberNational: result.phone_number_national,
                phoneNumber: result.phone_number
              };
            })
          });

        case 12:
        case "end":
          return _context48.stop();
      }
    }, _callee48);
  }));

  return function (_x84, _x85) {
    return _ref145.apply(this, arguments);
  };
}());
var updateTravelAgent = f.fetcher( /*#__PURE__*/function () {
  var _ref147 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(_ref146, travelAgent) {
    var _data$paypal_accounts2;

    var ctx, patch, travelAgentUrl, _yield$patch3, data;

    return _regeneratorRuntime.wrap(function _callee49$(_context49) {
      while (1) switch (_context49.prev = _context49.next) {
        case 0:
          ctx = _ref146.ctx, patch = _ref146.patch;
          travelAgentUrl = urlConfig[ctx.env].travelAgentUrl;
          _context49.next = 4;
          return patch("".concat(travelAgentUrl), travelAgentSchema, _objectSpread({
            abta_atol_code: travelAgent.abtaAtolCode,
            trade_id: travelAgent.tradeId,
            iata_code: travelAgent.iataCode,
            travel_agency_website: travelAgent.travelAgencyWebsite,
            travel_agency_social_link: travelAgent.travelAgencySocialLink,
            currency: travelAgent.currency,
            commission: travelAgent.commissionType ? travelAgent.commissionType === "fixed" ? Number(travelAgent.commissionFixed) : 0 : void 0,
            commission_percentage: travelAgent.commissionType ? travelAgent.commissionType === "percentage" ? Number(travelAgent.commissionPercentage) : 0 : void 0
          }, travelAgent.taxId ? {
            tax_id: travelAgent.taxId
          } : {}));

        case 4:
          _yield$patch3 = _context49.sent;
          data = _yield$patch3.data;

          if (!("code" in data)) {
            _context49.next = 8;
            break;
          }

          throw new AuthError();

        case 8:
          return _context49.abrupt("return", {
            company: {
              name: data.company.name,
              payoutToMaster: data.company.payout_to_master
            },
            taxId: data.tax_id,
            commissionType: data.commission_percentage > 0 ? "percentage" : "fixed",
            commissionFixed: data.commission,
            commissionPercentage: data.commission_percentage,
            currency: data.currency,
            iataCode: data.iata_code,
            abtaAtolCode: data.abta_atol_code,
            tradeId: data.trade_id,
            travelAgencyWebsite: data.travel_agency_website,
            travelAgencySocialLink: data.travel_agency_social_link,
            paypalAccounts: (_data$paypal_accounts2 = data.paypal_accounts) === null || _data$paypal_accounts2 === void 0 ? void 0 : _data$paypal_accounts2.map(function (paypalAccount) {
              return {
                accountId: paypalAccount.account_id,
                paypalEmail: paypalAccount.paypal_email
              };
            }),
            position: data.position
          });

        case 9:
        case "end":
          return _context49.stop();
      }
    }, _callee49);
  }));

  return function (_x86, _x87) {
    return _ref147.apply(this, arguments);
  };
}());
var errorResponseSchema = zod.z.object({
  non_field_errors: zod.z.array(zod.z.object({
    message: zod.z.string(),
    code: zod.z.string(),
    user_message: zod.z.string().nullable()
  })).optional(),
  profile_name: zod.z.array(zod.z.object({
    message: zod.z.string(),
    code: zod.z.string(),
    user_message: zod.z.string().nullable()
  })).optional()
});
var createCustomerProfileResponseSchema = zod.z.union([customerProfileSchema, authErrorSchema, errorResponseSchema]);
var createCustomerProfile = f.fetcher( /*#__PURE__*/function () {
  var _ref150 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(_ref148, _ref149) {
    var ctx, post, profileName, firstName, lastName, email, countryCodeName, phoneNumber, travelAgentUrl, _yield$post18, data, mergedErrors;

    return _regeneratorRuntime.wrap(function _callee50$(_context50) {
      while (1) switch (_context50.prev = _context50.next) {
        case 0:
          ctx = _ref148.ctx, post = _ref148.post;
          profileName = _ref149.profileName, firstName = _ref149.firstName, lastName = _ref149.lastName, email = _ref149.email, countryCodeName = _ref149.countryCodeName, phoneNumber = _ref149.phoneNumber;
          travelAgentUrl = urlConfig[ctx.env].travelAgentUrl;
          _context50.next = 5;
          return post("".concat(travelAgentUrl, "profiles/"), createCustomerProfileResponseSchema, {
            profile_name: profileName,
            first_name: firstName,
            last_name: lastName,
            email: email,
            country_code_name: countryCodeName,
            phone_number: phoneNumber
          });

        case 5:
          _yield$post18 = _context50.sent;
          data = _yield$post18.data;

          if (!("code" in data)) {
            _context50.next = 9;
            break;
          }

          throw new AuthError();

        case 9:
          if ("id" in data) {
            _context50.next = 12;
            break;
          }

          mergedErrors = [].concat(_toConsumableArray(data.non_field_errors || []), _toConsumableArray(data.profile_name || [])).map(function (error) {
            return {
              message: error.message,
              code: error.code,
              userMessage: error.user_message
            };
          });
          return _context50.abrupt("return", {
            errors: mergedErrors
          });

        case 12:
          return _context50.abrupt("return", {
            id: data.id,
            profileName: data.profile_name,
            firstName: data.first_name,
            lastName: data.last_name,
            email: data.email,
            countryCode: data.country_code,
            countryCodeName: data.country_code_name,
            phoneNumberNational: data.phone_number_national,
            phoneNumber: data.phone_number
          });

        case 13:
        case "end":
          return _context50.stop();
      }
    }, _callee50);
  }));

  return function (_x88, _x89) {
    return _ref150.apply(this, arguments);
  };
}());
var addPaypalAccount = f.fetcher( /*#__PURE__*/function () {
  var _ref153 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51(_ref151, _ref152) {
    var ctx, post, paypalEmail, travelAgentUrl, _yield$post19, data;

    return _regeneratorRuntime.wrap(function _callee51$(_context51) {
      while (1) switch (_context51.prev = _context51.next) {
        case 0:
          ctx = _ref151.ctx, post = _ref151.post;
          paypalEmail = _ref152.paypalEmail;
          travelAgentUrl = urlConfig[ctx.env].travelAgentUrl;
          _context51.next = 5;
          return post("".concat(travelAgentUrl, "paypal_account/"), zod.z.object({
            account_id: zod.z.number(),
            paypal_email: zod.z.string()
          }), {
            paypal_email: paypalEmail
          });

        case 5:
          _yield$post19 = _context51.sent;
          data = _yield$post19.data;
          return _context51.abrupt("return", {
            accountId: data.account_id,
            paypalEmail: data.paypal_email
          });

        case 8:
        case "end":
          return _context51.stop();
      }
    }, _callee51);
  }));

  return function (_x90, _x91) {
    return _ref153.apply(this, arguments);
  };
}());
var updateCustomerProfileResponseSchema = zod.z.union([customerProfileSchema, authErrorSchema, errorResponseSchema]);
var updateCustomerProfile = f.fetcher( /*#__PURE__*/function () {
  var _ref156 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52(_ref154, _ref155) {
    var ctx, patch, id, profileName, firstName, lastName, email, countryCodeName, phoneNumber, travelAgentUrl, _yield$patch4, data, mergedErrors;

    return _regeneratorRuntime.wrap(function _callee52$(_context52) {
      while (1) switch (_context52.prev = _context52.next) {
        case 0:
          ctx = _ref154.ctx, patch = _ref154.patch;
          id = _ref155.id, profileName = _ref155.profileName, firstName = _ref155.firstName, lastName = _ref155.lastName, email = _ref155.email, countryCodeName = _ref155.countryCodeName, phoneNumber = _ref155.phoneNumber;
          travelAgentUrl = urlConfig[ctx.env].travelAgentUrl;
          _context52.next = 5;
          return patch("".concat(travelAgentUrl, "profiles/").concat(id, "/"), updateCustomerProfileResponseSchema, {
            profile_name: profileName,
            first_name: firstName,
            last_name: lastName,
            email: email,
            country_code_name: countryCodeName,
            phone_number: phoneNumber
          });

        case 5:
          _yield$patch4 = _context52.sent;
          data = _yield$patch4.data;

          if (!("code" in data)) {
            _context52.next = 9;
            break;
          }

          throw new AuthError();

        case 9:
          if ("id" in data) {
            _context52.next = 12;
            break;
          }

          mergedErrors = [].concat(_toConsumableArray(data.non_field_errors || []), _toConsumableArray(data.profile_name || [])).map(function (error) {
            return {
              message: error.message,
              code: error.code,
              userMessage: error.user_message
            };
          });
          return _context52.abrupt("return", {
            errors: mergedErrors
          });

        case 12:
          return _context52.abrupt("return", {
            id: data.id,
            profileName: data.profile_name,
            firstName: data.first_name,
            lastName: data.last_name,
            email: data.email,
            countryCode: data.country_code,
            countryCodeName: data.country_code_name,
            phoneNumberNational: data.phone_number_national,
            phoneNumber: data.phone_number
          });

        case 13:
        case "end":
          return _context52.stop();
      }
    }, _callee52);
  }));

  return function (_x92, _x93) {
    return _ref156.apply(this, arguments);
  };
}());
var deleteCustomerProfile = f.fetcher( /*#__PURE__*/function () {
  var _ref158 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53(_ref157, id) {
    var _headers$Authorizatio;

    var ctx, headers, travelAgentUrl, response;
    return _regeneratorRuntime.wrap(function _callee53$(_context53) {
      while (1) switch (_context53.prev = _context53.next) {
        case 0:
          ctx = _ref157.ctx, headers = _ref157.headers;
          travelAgentUrl = urlConfig[ctx.env].travelAgentUrl;
          _context53.next = 4;
          return fetch("".concat(travelAgentUrl, "profiles/").concat(id), {
            method: "DELETE",
            headers: _objectSpread(_objectSpread({}, headers), {}, {
              Authorization: (_headers$Authorizatio = headers.Authorization) !== null && _headers$Authorizatio !== void 0 ? _headers$Authorizatio : ""
            })
          });

        case 4:
          response = _context53.sent;

          if (!(response.status !== 204)) {
            _context53.next = 7;
            break;
          }

          throw new Error("Failed to delete travel agent profile");

        case 7:
          return _context53.abrupt("return", id);

        case 8:
        case "end":
          return _context53.stop();
      }
    }, _callee53);
  }));

  return function (_x94, _x95) {
    return _ref158.apply(this, arguments);
  };
}());
var deletePaypalAccount = f.fetcher( /*#__PURE__*/function () {
  var _ref160 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54(_ref159, id) {
    var ctx, headers, travelAgentUrl, response;
    return _regeneratorRuntime.wrap(function _callee54$(_context54) {
      while (1) switch (_context54.prev = _context54.next) {
        case 0:
          ctx = _ref159.ctx, headers = _ref159.headers;
          travelAgentUrl = urlConfig[ctx.env].travelAgentUrl;

          if (headers.Authorization) {
            _context54.next = 4;
            break;
          }

          throw new AuthError();

        case 4:
          _context54.next = 6;
          return fetch("".concat(travelAgentUrl, "paypal_account/").concat(id), {
            method: "DELETE",
            headers: _objectSpread(_objectSpread({}, headers), {}, {
              Authorization: headers.Authorization
            })
          });

        case 6:
          response = _context54.sent;

          if (!response.ok) {
            _context54.next = 9;
            break;
          }

          return _context54.abrupt("return", id);

        case 9:
          throw new Error("Something went wrong, please try again!");

        case 10:
        case "end":
          return _context54.stop();
      }
    }, _callee54);
  }));

  return function (_x96, _x97) {
    return _ref160.apply(this, arguments);
  };
}());
var createTravelAgentQuery = f.combineFetchers({
  getTravelAgent: getTravelAgent,
  getCustomerProfiles: getCustomerProfiles,
  updateTravelAgent: updateTravelAgent,
  createCustomerProfile: createCustomerProfile,
  updateCustomerProfile: updateCustomerProfile,
  deleteCustomerProfile: deleteCustomerProfile,
  addPaypalAccount: addPaypalAccount,
  deletePaypalAccount: deletePaypalAccount
});
exports.AuthError = AuthError;
exports.DISCOUNT_TYPE = DISCOUNT_TYPE;
exports.DRIVER_TRIP_STATUS = DRIVER_TRIP_STATUS;
exports.ERROR_CODES = ERROR_CODES;
exports.FLIGHT_DIRECTION = FLIGHT_DIRECTION;
exports.PARKING_FEATURE_TYPE = PARKING_FEATURE_TYPE;
exports.PARKING_STATUS_TYPE = PARKING_STATUS_TYPE;
exports.PARKING_TRANSFER_TYPE = PARKING_TRANSFER_TYPE;
exports.PURCHASE_ESIM_STATUS = PURCHASE_ESIM_STATUS;
exports.USER_TYPE = USER_TYPE;
exports.createAuthDriverQuery = createAuthDriverQuery;
exports.createAuthQuery = createAuthQuery;
exports.createConfirmationQuery = createConfirmationQuery;
exports.createCurrencyQuery = createCurrencyQuery;
exports.createDriverQuery = createDriverQuery;
exports.createEsimQuery = createEsimQuery;
exports.createFlightQuery = createFlightQuery;
exports.createHertzQuery = createHertzQuery;
exports.createLocationQuery = createLocationQuery;
exports.createParkingQuery = createParkingQuery;
exports.createProviderQuery = createProviderQuery;
exports.createTransferQuery = createTransferQuery;
exports.createTravelAgentQuery = createTravelAgentQuery;
exports.createUsersQuery = createUsersQuery;
exports.createWhiteLabelQuery = createWhiteLabelQuery;
exports.envSchema = envSchema;
exports.whiteLabelServices = whiteLabelServices;